var _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomecinemaAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Background--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--background--inject-40",
    d: "M69.23,415.75C2.92,357.63-1.16,214,55,135.42,145,9.5,292.06,4.88,397.41,78.71c92,64.49,99.88,218.81,69.26,289.27-21.32,49-76.29,108-196,111.79C164.89,483.09,112,453.24,69.23,415.75Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-40"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "123.6 129.01 125.09 129.9 155.83 112.16 154.33 111.27 123.6 129.01"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "154.33 111.27 125.09 128.14 125.09 97.53 154.33 80.66 154.33 111.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.81 124.29 152.78 109.29 152.78 104.31 148.1 99.15 144 106.06 146.85 109.37 133.76 102.22 126.81 115.87 126.81 124.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.48,91.69c1.11-.64,2-.12,2,1.16a4.43,4.43,0,0,1-2,3.48c-1.11.64-2,.12-2-1.16A4.44,4.44,0,0,1,144.48,91.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.83 79.78 154.33 80.66 154.33 111.27 155.83 112.16 155.83 79.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,74.89l-36.38,21v38.9l36.38-21Zm-2.82,37.27L125.09,129.9V97.53l30.73-17.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.65 74.89 157.13 74.02 120.75 95.03 122.27 95.9 158.65 74.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.75 95.03 122.27 95.9 122.27 134.8 120.75 133.93 120.75 95.03",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-40"
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.56 181.65 77.06 182.54 107.79 164.8 106.29 163.91 75.56 181.65"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "106.29 163.91 77.06 180.78 77.06 150.17 106.3 133.3 106.29 163.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.69 177.68 104.66 162.68 104.66 157.69 99.98 152.54 95.88 159.45 98.73 162.76 85.64 155.61 78.69 169.26 78.69 177.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.36,145.08c1.11-.64,2-.12,2,1.16a4.44,4.44,0,0,1-2,3.48c-1.11.64-2,.12-2-1.16A4.44,4.44,0,0,1,96.36,145.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.79 132.42 106.3 133.3 106.29 163.91 107.79 164.8 107.79 132.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62,127.53l-36.39,21v38.91l36.39-21Zm-2.83,37.27L77.06,182.54V150.17l30.73-17.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.62 127.53 109.1 126.66 72.71 147.66 74.23 148.53 110.62 127.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.71 147.66 74.23 148.53 74.23 187.44 72.71 186.57 72.71 147.66",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker-2--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speaker--inject-40"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-40",
    d: "M210.87,171,190,183c-1.32.77-1.32,2,0,2.77l24.87,14.36a5.28,5.28,0,0,0,4.8,0l20.84-12c1.32-.76,1.32-2,0-2.77L215.67,171A5.34,5.34,0,0,0,210.87,171Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.12,185.13a1.35,1.35,0,0,0-.79-1.12L215.87,172.2a4.28,4.28,0,0,0-3.85,0l-14.2,8.21a1.34,1.34,0,0,0-.8,1.11v2.26a1.33,1.33,0,0,0,.8,1.11l20.45,11.81a4.22,4.22,0,0,0,3.85,0l14.21-8.2a1.35,1.35,0,0,0,.79-1.11C237.13,187,237.12,185.53,237.12,185.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,172.2l-14.2,8.21a1.17,1.17,0,0,0,0,2.22l20.45,11.81a4.28,4.28,0,0,0,3.85,0l14.21-8.2a1.18,1.18,0,0,0,0-2.23L215.87,172.2A4.28,4.28,0,0,0,212,172.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,172.2c-3,1.87-6.11,3.72-9.18,5.53l-4.63,2.71a2,2,0,0,0-.89.77.82.82,0,0,0,.26.95,8.09,8.09,0,0,0,1.08.68l1.16.66,9.26,5.41q4.62,2.73,9.19,5.53-4.71-2.56-9.38-5.19l-9.32-5.32-1.15-.67a6.46,6.46,0,0,1-1.17-.76,1.28,1.28,0,0,1-.35-1.48,2.37,2.37,0,0,1,1.08-1l4.66-2.65Q207.32,174.76,212,172.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.76 156.63 214.63 151.94 212.14 153.38 212.14 181.52 220.26 186.21 222.76 184.77 222.76 156.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.14 181.52 212.14 153.38 220.26 158.07 220.26 186.21 212.14 181.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.14,153.38v13.83l5.48,3.17a3.94,3.94,0,0,0,3.57,0l1.57-.9V156.63l-8.13-4.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.17,80.1l18.19,10.5a4,4,0,0,1,1.78,3.09v62.57a3.94,3.94,0,0,1-1.78,3.09L221.19,167a3.94,3.94,0,0,1-3.57,0l-18.18-10.49a3.94,3.94,0,0,1-1.78-3.09V90.79a3.92,3.92,0,0,1,1.78-3.09l13.16-7.6A3.94,3.94,0,0,1,216.17,80.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.62,100.26l-18.18-10.5c-1-.57-1.78-.11-1.78,1v62.58a3.94,3.94,0,0,0,1.78,3.09L217.62,167c1,.57,1.79.11,1.79-1V103.35A3.94,3.94,0,0,0,217.62,100.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,90.79l.11,23.9,0,9,.08,18.11,0,9.06v2.26a3.85,3.85,0,0,0,1.3,2.86,6.08,6.08,0,0,0,.92.6l2,1.14,7.82,4.56,7.78,4.62-7.89-4.42-7.87-4.5-2-1.12a5.74,5.74,0,0,1-1-.62,4.41,4.41,0,0,1-.78-.89,3.92,3.92,0,0,1-.67-2.23v-2.26l0-9.06.08-18.11,0-9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.19,100.26l13.17-7.6c1-.57,1.78-.11,1.78,1v62.57a3.94,3.94,0,0,1-1.78,3.09L221.19,167c-1,.57-1.78.11-1.78-1V103.35A4,4,0,0,1,221.19,100.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6,80.1l-13.16,7.6a1.09,1.09,0,0,0,0,2.06l18.18,10.5a3.94,3.94,0,0,0,3.57,0l13.17-7.6a1.09,1.09,0,0,0,0-2.06L216.17,80.1A3.94,3.94,0,0,0,212.6,80.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,133.93A16.58,16.58,0,0,1,201,121c0-4.77,3.36-6.71,7.49-4.32a16.55,16.55,0,0,1,7.49,13C216,134.38,212.67,136.32,208.53,133.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,133.06a14.9,14.9,0,0,1-6.74-11.67c0-4.3,3-6,6.74-3.89a14.9,14.9,0,0,1,6.74,11.67C215.27,133.47,212.25,135.21,208.53,133.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,129.82A8.68,8.68,0,0,1,204.6,123c0-2.51,1.76-3.53,3.93-2.27a8.69,8.69,0,0,1,3.94,6.81C212.47,130.06,210.7,131.08,208.53,129.82Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,129.82A8.68,8.68,0,0,1,204.6,123c0-2.51,1.76-3.53,3.93-2.27a8.69,8.69,0,0,1,3.94,6.81C212.47,130.06,210.7,131.08,208.53,129.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,126.63a2.6,2.6,0,0,1-1.17-2c0-.74.53-1,1.17-.67a2.57,2.57,0,0,1,1.17,2C209.7,126.7,209.18,127,208.53,126.63Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,112.13a10.12,10.12,0,0,1-4.57-7.92c0-2.92,2-4.1,4.57-2.64a10.1,10.1,0,0,1,4.58,7.92C213.11,112.41,211.06,113.59,208.53,112.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,111.6a9.09,9.09,0,0,1-4.11-7.13c0-2.62,1.84-3.68,4.11-2.37a9.1,9.1,0,0,1,4.12,7.13C212.65,111.85,210.8,112.91,208.53,111.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,109.62a5.29,5.29,0,0,1-2.4-4.16c0-1.53,1.07-2.15,2.4-1.38a5.28,5.28,0,0,1,2.4,4.16C210.93,109.77,209.86,110.39,208.53,109.62Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,109.62a5.29,5.29,0,0,1-2.4-4.16c0-1.53,1.07-2.15,2.4-1.38a5.28,5.28,0,0,1,2.4,4.16C210.93,109.77,209.86,110.39,208.53,109.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,107.67a1.57,1.57,0,0,1-.71-1.23c0-.46.32-.64.71-.41a1.55,1.55,0,0,1,.72,1.23C209.25,107.72,208.93,107.9,208.53,107.67Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,155.5a16.55,16.55,0,0,1-7.49-13c0-4.78,3.36-6.71,7.49-4.33a16.56,16.56,0,0,1,7.49,13C216,156,212.67,157.89,208.53,155.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,154.64A14.91,14.91,0,0,1,201.79,143c0-4.3,3-6,6.74-3.89a14.91,14.91,0,0,1,6.74,11.68C215.27,155,212.25,156.79,208.53,154.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,151.4a8.72,8.72,0,0,1-3.93-6.82c0-2.51,1.76-3.52,3.93-2.27a8.73,8.73,0,0,1,3.94,6.82C212.47,151.64,210.7,152.65,208.53,151.4Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,151.4a8.72,8.72,0,0,1-3.93-6.82c0-2.51,1.76-3.52,3.93-2.27a8.73,8.73,0,0,1,3.94,6.82C212.47,151.64,210.7,152.65,208.53,151.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,148.2a2.6,2.6,0,0,1-1.17-2c0-.75.53-1.05,1.17-.68a2.59,2.59,0,0,1,1.17,2C209.7,148.27,209.18,148.58,208.53,148.2Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,91.79a1.39,1.39,0,0,1,.64,1.1c0,.41-.28.57-.64.37a1.4,1.4,0,0,1-.63-1.1C199,91.75,199.25,91.58,199.6,91.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,101.89a1.42,1.42,0,0,1,.63,1.11c0,.4-.28.57-.63.36a1.4,1.4,0,0,1-.64-1.1C216.46,101.85,216.75,101.69,217.1,101.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,153.14a1.39,1.39,0,0,1,.64,1.1c0,.41-.28.58-.64.37a1.4,1.4,0,0,1-.63-1.1C199,153.1,199.25,152.94,199.6,153.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,163.24a1.42,1.42,0,0,1,.63,1.11c0,.41-.28.57-.63.37a1.43,1.43,0,0,1-.64-1.11C216.46,163.21,216.75,163,217.1,163.24Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--TV--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tv-stand--inject-40"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M376.2,306.26l37.26-21.51c1.48-.85,1.48-2.23,0-3.08L271.84,199.9a5.91,5.91,0,0,0-5.34,0l-37.26,21.51c-1.48.85-1.48,2.24,0,3.09l141.62,81.76A5.91,5.91,0,0,0,376.2,306.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bookshelf--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Side--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.75,176.07l34.76-20a1.87,1.87,0,0,1,1.88-.18l2.51,1.44a1.88,1.88,0,0,1,.79,1.74v37.12a5.93,5.93,0,0,1-2.67,4.63l-34.76,20a1.87,1.87,0,0,1-1.89.19l-2.51-1.45a1.89,1.89,0,0,1-.78-1.73V180.7A5.91,5.91,0,0,1,236.75,176.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.17,197.79l2.51,1.45v7.91a1.46,1.46,0,0,1-.66,1.15l-1.17.68a1.5,1.5,0,0,1-1.34,0l-1.17-.68a2.38,2.38,0,0,1-.92-1.11l-2.25-6.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67,207.15a1.46,1.46,0,0,1-.66,1.15l-1.17.68a.61.61,0,0,1-.92-.35l-2.26-6.5,5-2.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.11,212.23l2.5,1.44v7.91a1.49,1.49,0,0,1-.66,1.16l-1.17.68a1.5,1.5,0,0,1-1.34,0l-1.17-.68a2.38,2.38,0,0,1-.92-1.11l-2.25-6.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.61,221.58a1.49,1.49,0,0,1-.66,1.16l-1.17.68a.62.62,0,0,1-.92-.35l-2.26-6.5,5-2.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.84,157.53l-34.76,20a5.94,5.94,0,0,0-2.67,4.63v37.13a1.89,1.89,0,0,0,.78,1.73,1.87,1.87,0,0,0,1.89-.19l34.76-20a5.91,5.91,0,0,0,2.67-4.62V159.07a1.63,1.63,0,0,0-2.67-1.54Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "408.61 278.26 371.02 299.97 234.09 220.91 236.59 219.46 274.18 197.75 408.61 275.37 408.61 278.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.02 299.97 371.02 297.07 234.09 218.01 234.09 220.91 371.02 299.97",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-40",
    points: "239.1 207.26 245.99 218.72 368.51 289.51 368.51 281.98 239.1 207.26",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Console--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M286.51,226.5l-15.67,9.05a3.11,3.11,0,0,1-2.82,0L248.7,224.27a.86.86,0,0,1,0-1.63l15.67-9a3.09,3.09,0,0,1,2.81,0l19.33,11.28A.85.85,0,0,1,286.51,226.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,224.76v1.33L270,234.47a1.24,1.24,0,0,1-.52.18,1.45,1.45,0,0,1-.93-.18L250.25,223.9v-1.38L268,232.82a2.78,2.78,0,0,0,2.51,0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,224.76v1.33L270,234.47a1.24,1.24,0,0,1-.52.18,1.45,1.45,0,0,1-.93-.18L250.25,223.9v-1.38L268,232.82a2.78,2.78,0,0,0,2.51,0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,224.76v1.33L270,234.47a1.24,1.24,0,0,1-.52.18h-.21v-1.54a2.47,2.47,0,0,0,1.26-.3Z",
    style: {
      fill: "#FB923C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.55,232.83l14-8.07a2.79,2.79,0,0,0,1.25-2.18V220a2.79,2.79,0,0,0-1.25-2.18l-17.8-10.26a2.78,2.78,0,0,0-2.51,0l-14,8.07A2.75,2.75,0,0,0,249,217.8v2.59a2.68,2.68,0,0,0,1.26,2.13L268,232.83A2.78,2.78,0,0,0,270.55,232.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,214.69l15.24,3.13a2.79,2.79,0,0,1,1.25,2.18v2.58a2.79,2.79,0,0,1-1.25,2.18l-14,8.07a2.58,2.58,0,0,1-1.26.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,219.27l-14,8.07a2.78,2.78,0,0,1-2.51,0l-17.79-10.26a.76.76,0,0,1,0-1.45l14-8.07a2.78,2.78,0,0,1,2.51,0l17.8,10.26A.77.77,0,0,1,284.53,219.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.74,217a.82.82,0,0,1,0,1.55,3,3,0,0,1-2.7,0,.82.82,0,0,1,0-1.55A3,3,0,0,1,268.74,217Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.52,219.77a1.07,1.07,0,0,1,.49.85c0,.32-.22.45-.49.3a1.08,1.08,0,0,1-.49-.85C252,219.75,252.25,219.61,252.52,219.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.52,221.66a1.1,1.1,0,0,1,.49.86c0,.32-.22.45-.49.3A1.1,1.1,0,0,1,252,222C252,221.64,252.25,221.51,252.52,221.66Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M361.33,288.86l20.42-11.77a.63.63,0,0,0,0-1.2l-28.41-16.4a2.25,2.25,0,0,0-2.08,0l-20.42,11.77a.63.63,0,0,0,0,1.2l28.41,16.4A2.25,2.25,0,0,0,361.33,288.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "378.75 276.5 359.98 287.17 332.75 271.53 351.52 260.87 378.75 276.5",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.75 276.5 359.98 287.17 332.75 271.53 351.52 260.87 378.75 276.5",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.84,286.63l18.34-10.46a3.16,3.16,0,0,1,.06-2.45L360,284.11S359.75,284.22,359.84,286.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,283.15a2.5,2.5,0,0,0-1.14,2v1.66c0,.72.51,1,1.14.65l18.17-10.36v-.57l-18,10.23c-.38.22-.68,0-.68-.39v-1.49a1.52,1.52,0,0,1,.68-1.18l18-10.24v-.64Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,283.15a2.5,2.5,0,0,0-1.14,2v1.66c0,.72.51,1,1.14.65l18.17-10.36v-.57l-18,10.23c-.38.22-.68,0-.68-.39v-1.49a1.52,1.52,0,0,1,.68-1.18l18-10.24v-.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,272.79l-27.23-15.63-18.17,10.36a2.5,2.5,0,0,0-1.14,2v1.66a.79.79,0,0,0,.34.73l27.23,15.63a.81.81,0,0,1-.34-.73v-1.66a2.5,2.5,0,0,1,1.14-2Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,272.79l-27.23-15.63-18.17,10.36a2.5,2.5,0,0,0-1.14,2v1.66a.79.79,0,0,0,.34.73l27.23,15.63a.81.81,0,0,1-.34-.73v-1.66a2.5,2.5,0,0,1,1.14-2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,284a2.25,2.25,0,0,0-.34,1.12v1.66a.81.81,0,0,0,.34.73l-27.23-15.63a.79.79,0,0,1-.34-.73v-1.66a2.25,2.25,0,0,1,.34-1.12Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,284a2.25,2.25,0,0,0-.34,1.12v1.66a.78.78,0,0,0,.33.73l-27.23-15.63a.79.79,0,0,1-.34-.73v-1.66a2.25,2.25,0,0,1,.34-1.12Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,269.89a5.74,5.74,0,0,0,0,3.54l.94.54a5.78,5.78,0,0,1,0-3.53Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63,281.62a5.72,5.72,0,0,0,0,3.51l.95.54a5.64,5.64,0,0,1,0-3.51Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.23,269.89a5.74,5.74,0,0,0,0,3.54l.94.54a5.78,5.78,0,0,1,0-3.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63,281.62a5.72,5.72,0,0,0,0,3.51l.95.54a5.64,5.64,0,0,1,0-3.51Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.16 272.89 362.38 283.56 335.15 267.93 353.93 257.26 381.16 272.89",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.16 272.89 362.38 283.56 335.15 267.93 353.93 257.26 381.16 272.89",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.24,283l18.34-10.46a2.86,2.86,0,0,1,.07-2.32l-18.27,10.39S362.16,280.62,362.24,283Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,279.67a2.5,2.5,0,0,0-1.14,2v1.53c0,.72.51,1,1.14.65l18.17-10.36v-.57l-18,10.23c-.38.22-.69.05-.69-.39v-1.36a1.51,1.51,0,0,1,.69-1.18l18-10.24v-.64Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,279.67a2.5,2.5,0,0,0-1.14,2v1.53c0,.72.51,1,1.14.65l18.17-10.36v-.57l-18,10.23c-.38.22-.69.05-.69-.39v-1.36a1.51,1.51,0,0,1,.69-1.18l18-10.24v-.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.16,269.31l-27.23-15.63L335.76,264a2.5,2.5,0,0,0-1.14,2v1.53a.8.8,0,0,0,.33.73l27.23,15.63a.8.8,0,0,1-.33-.73v-1.54a2.5,2.5,0,0,1,1.14-2Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.16,269.31l-27.23-15.63L335.76,264a2.5,2.5,0,0,0-1.14,2v1.53a.8.8,0,0,0,.33.73l27.23,15.63a.8.8,0,0,1-.33-.73v-1.54a2.5,2.5,0,0,1,1.14-2Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18,280.52a2.33,2.33,0,0,0-.33,1.11v1.54a.8.8,0,0,0,.33.73L335,268.27a.8.8,0,0,1-.33-.73V266a2.34,2.34,0,0,1,.33-1.12Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18,280.52a2.33,2.33,0,0,0-.33,1.11v1.54a.8.8,0,0,0,.33.73L335,268.27a.8.8,0,0,1-.33-.73V266a2.34,2.34,0,0,1,.33-1.12Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.63,266.41a5.4,5.4,0,0,0,0,3.41l.95.54a5.33,5.33,0,0,1,0-3.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,278.13a5.27,5.27,0,0,0,0,3.39l.94.55a5.34,5.34,0,0,1,0-3.39Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "239.1 204.37 239.1 207.26 371.02 283.43 408.61 261.73 408.61 258.83 276.69 182.67 239.1 204.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.1 204.37 371.02 280.54 408.61 258.83 276.69 182.67 239.1 204.37",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--side--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.18,253.65l34.76-20a1.87,1.87,0,0,1,1.89-.19l2.5,1.44a1.88,1.88,0,0,1,.79,1.74v37.12a5.91,5.91,0,0,1-2.67,4.63l-34.76,20a1.87,1.87,0,0,1-1.88.18l-2.52-1.45a1.89,1.89,0,0,1-.78-1.73V258.28A5.93,5.93,0,0,1,371.18,253.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.02 268.25 368.51 266.8 368.51 258.11 371.03 259.56 371.02 268.25",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.41 190.57 234.07 189.19 234.07 180.5 236.42 181.88 236.41 190.57",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.6,275.37l2.51,1.45v7.91a1.47,1.47,0,0,1-.67,1.15l-1.17.68a1.5,1.5,0,0,1-1.34,0l-1.17-.68a2.38,2.38,0,0,1-.92-1.11l-2.25-6.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.11,284.73a1.47,1.47,0,0,1-.67,1.15l-1.17.68a.61.61,0,0,1-.92-.34l-2.26-6.51,5-2.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.54,289.81l2.51,1.44v7.91a1.47,1.47,0,0,1-.67,1.16l-1.17.68a1.5,1.5,0,0,1-1.34,0l-1.17-.68a2.38,2.38,0,0,1-.92-1.11l-2.25-6.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.05,299.16a1.47,1.47,0,0,1-.67,1.16l-1.17.68a.61.61,0,0,1-.92-.35l-2.26-6.5,5-2.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.45,235.07l-34.76,20a5.91,5.91,0,0,0-2.67,4.63V300l2.67-1.57,34.76-20a5.91,5.91,0,0,0,2.67-4.63V236.61a1.62,1.62,0,0,0-2.67-1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.69,255.1l34.76-20a1.62,1.62,0,0,1,2.67,1.54v8.49L371,268.25v-8.52A5.91,5.91,0,0,1,373.69,255.1Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-40",
    points: "236.59 184.76 243.49 196.23 368.51 268.46 368.52 260.93 236.59 184.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.38,238.86a7.05,7.05,0,0,0,4.44.29l1.93-.48a7,7,0,0,1,4.43.28,2.93,2.93,0,0,1,1.58,2.36l-.29,3c-.07.77,0,1.57,1.58,2.36a2.49,2.49,0,0,0,3-.24l5.4-5.16c.7-.67.29-1.77-.91-2.46l-9.28-5.3a5,5,0,0,0-4.2-.24l-7.36,3.64C301.56,237.43,301.43,238.32,302.38,238.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.38,237.47a2.17,2.17,0,0,0-1.25-1.66l-9.28-5.3a5,5,0,0,0-4.2-.25l-7.37,3.64c-.64.32-.95.75-.92,1.16s.05,1.47.08,1.81a1.12,1.12,0,0,0,.63.8,7.08,7.08,0,0,0,4.45.29l1.92-.49a7,7,0,0,1,4.43.29,3.46,3.46,0,0,1,1.41,1.51l-.2,2a2.08,2.08,0,0,0,.15,1.14l-.07.64c-.07.76,0,1.56,1.58,2.36a2.5,2.5,0,0,0,3-.24l5.4-5.16a1.09,1.09,0,0,0,.35-.81C324.46,238.92,324.39,237.76,324.38,237.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85,240.62l-.67-5.25-2.69-.79.14,2.78a3.85,3.85,0,0,1,1.24.4,3.46,3.46,0,0,1,1.41,1.51l-.08.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.75,236.26c.9.88,1,1.16,1.25,4.75.15,1.88-.87,3.21-1.68,2.62s-1-1.79-1.82-1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,235.88a7,7,0,0,0,4.44.3l1.93-.49a7,7,0,0,1,4.43.29,2.94,2.94,0,0,1,1.58,2.36l-.29,3c-.07.76,0,1.56,1.58,2.36a2.51,2.51,0,0,0,3-.24l5.4-5.16c.7-.67.29-1.77-.91-2.46l-9.28-5.3a5,5,0,0,0-4.2-.25l-7.37,3.64C301.17,234.46,301,235.34,302,235.88Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,235.88a7,7,0,0,0,4.44.3l1.93-.49a7,7,0,0,1,4.43.29,2.94,2.94,0,0,1,1.58,2.36l-.29,3c-.07.76,0,1.56,1.58,2.36a2.51,2.51,0,0,0,3-.24l5.4-5.16c.7-.67.29-1.77-.91-2.46l-9.28-5.3a5,5,0,0,0-4.2-.25l-7.37,3.64C301.17,234.46,301,235.34,302,235.88Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,235.84a.38.38,0,0,0-.2-.26,1.06,1.06,0,0,0-1,0,.34.34,0,0,0-.19.31c0,.07,0,.35,0,.43a.39.39,0,0,0,.21.28,1,1,0,0,0,1,0,.33.33,0,0,0,.19-.29A3.67,3.67,0,0,0,321,235.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.12,237a.37.37,0,0,0-.2-.27,1,1,0,0,0-1,0,.33.33,0,0,0-.19.29c0,.08,0,.37,0,.45a.39.39,0,0,0,.21.28,1,1,0,0,0,1,0,.32.32,0,0,0,.2-.29C319.14,237.36,319.13,237.06,319.12,237Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.09,235.81a.38.38,0,0,0-.2-.28,1,1,0,0,0-1,0,.32.32,0,0,0-.19.29c0,.08,0,.36,0,.44a.37.37,0,0,0,.2.29,1,1,0,0,0,1,0,.32.32,0,0,0,.19-.3C319.11,236.17,319.1,235.89,319.09,235.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.08,237a.39.39,0,0,0-.21-.28,1.06,1.06,0,0,0-1,0,.34.34,0,0,0-.19.29c0,.08,0,.36,0,.43a.37.37,0,0,0,.21.3,1,1,0,0,0,1,0,.32.32,0,0,0,.2-.29C321.09,237.41,321.08,237.12,321.08,237Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,235.55c-.26.16-.25.42,0,.59a1,1,0,0,0,1,0c.27-.16.26-.42,0-.59A1.06,1.06,0,0,0,319.86,235.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.94,236.68c-.26.16-.26.42,0,.59a1,1,0,0,0,1,0c.27-.16.26-.42,0-.59A1,1,0,0,0,317.94,236.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.91,235.5c-.27.16-.26.42,0,.59a1.06,1.06,0,0,0,1,0c.27-.16.26-.42,0-.59A1,1,0,0,0,317.91,235.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.89,236.73c-.26.16-.26.42,0,.59a1,1,0,0,0,1,0c.27-.16.26-.42,0-.59A1.06,1.06,0,0,0,319.89,236.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.63 231.27 311.64 230.65 310.68 231.22 309.69 230.6 308.73 231.17 308.75 231.65 309.33 232.01 308.76 232.35 308.78 232.84 309.77 233.45 310.73 232.89 311.73 233.5 312.69 232.94 312.66 232.45 312.09 232.09 312.66 231.76 312.63 231.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.64 230.65 310.68 231.22 309.69 230.6 308.73 231.17 309.72 231.78 308.76 232.35 309.75 232.96 310.71 232.4 311.7 233.01 312.66 232.45 311.67 231.83 312.63 231.27 311.64 230.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.71 232.4 310.73 232.89 309.77 233.45 309.75 232.96 310.71 232.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.67 231.83 312.09 232.09 312.66 231.76 312.63 231.27 311.67 231.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.66 232.45 312.69 232.94 311.73 233.5 311.7 233.01 312.66 232.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.72 231.78 308.73 231.17 308.75 231.68 309.33 232.01 309.72 231.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M258.23,200.71l-9.38,5.41a.56.56,0,0,0,0,1.06l41.65,24.06a2.05,2.05,0,0,0,1.84,0l9.38-5.41a.57.57,0,0,0,0-1.07l-41.65-24A2,2,0,0,0,258.23,200.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.43,190.54,298.32,213a1.87,1.87,0,0,1,.84,1.45v10a1.87,1.87,0,0,1-.84,1.46l-6.19,3.57a1.84,1.84,0,0,1-1.68,0l-38.89-22.45a1.87,1.87,0,0,1-.84-1.46v-10a1.87,1.87,0,0,1,.84-1.45l6.19-3.57A1.84,1.84,0,0,1,259.43,190.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.45,217.53l-38.89-22.45c-.46-.27-.84-.05-.84.48v10a1.87,1.87,0,0,0,.84,1.46l38.89,22.45c.46.27.84.05.84-.48V219A1.87,1.87,0,0,0,290.45,217.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.13,217.53l6.19-3.57c.46-.27.84-.05.84.48v10a1.87,1.87,0,0,1-.84,1.46l-6.19,3.57c-.47.27-.84.05-.84-.48V219A1.85,1.85,0,0,1,292.13,217.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,190.54l-6.19,3.57a.51.51,0,0,0,0,1l38.89,22.45a1.84,1.84,0,0,0,1.68,0l6.19-3.57a.51.51,0,0,0,0-1l-38.89-22.45A1.84,1.84,0,0,0,257.75,190.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,208.15a7.76,7.76,0,0,1-3.52-6.1c0-2.24,1.57-3.15,3.52-2a7.79,7.79,0,0,1,3.52,6.1C260.31,208.36,258.73,209.27,256.79,208.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,207.74a7,7,0,0,1-3.17-5.48c0-2,1.42-2.84,3.17-1.83a7,7,0,0,1,3.17,5.49C260,207.94,258.54,208.75,256.79,207.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,206.22a4.09,4.09,0,0,1-1.85-3.2c0-1.18.83-1.66,1.85-1.07a4.09,4.09,0,0,1,1.85,3.2C258.64,206.33,257.81,206.81,256.79,206.22Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,206.22a4.09,4.09,0,0,1-1.85-3.2c0-1.18.83-1.66,1.85-1.07a4.09,4.09,0,0,1,1.85,3.2C258.64,206.33,257.81,206.81,256.79,206.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,204.72a1.21,1.21,0,0,1-.55-.95c0-.35.25-.49.55-.32a1.23,1.23,0,0,1,.55,1C257.34,204.75,257.09,204.9,256.79,204.72Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,224.57a7.79,7.79,0,0,1-3.52-6.1c0-2.24,1.58-3.15,3.52-2a7.77,7.77,0,0,1,3.53,6.1C288.75,224.78,287.17,225.69,285.22,224.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,224.16a7,7,0,0,1-3.16-5.48c0-2,1.41-2.84,3.16-1.83a7,7,0,0,1,3.17,5.48C288.39,224.35,287,225.17,285.22,224.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,222.64a4.09,4.09,0,0,1-1.85-3.2c0-1.18.83-1.66,1.85-1.07a4.06,4.06,0,0,1,1.85,3.2C287.07,222.75,286.25,223.23,285.22,222.64Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,222.64a4.09,4.09,0,0,1-1.85-3.2c0-1.18.83-1.66,1.85-1.07a4.06,4.06,0,0,1,1.85,3.2C287.07,222.75,286.25,223.23,285.22,222.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,221.14a1.23,1.23,0,0,1-.55-.95c0-.35.25-.5.55-.32a1.2,1.2,0,0,1,.55.95C285.77,221.17,285.53,221.31,285.22,221.14Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,218.25a5.08,5.08,0,0,1-2.29-4c0-1.46,1-2.05,2.29-1.32a5.05,5.05,0,0,1,2.29,4C279,218.39,278,219,276.74,218.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,218a4.56,4.56,0,0,1-2.06-3.57c0-1.32.92-1.85,2.06-1.19a4.53,4.53,0,0,1,2.06,3.57C278.8,218.11,277.88,218.64,276.74,218Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,217a2.68,2.68,0,0,1-1.2-2.09c0-.77.54-1.08,1.2-.69a2.62,2.62,0,0,1,1.2,2.08C277.94,217.07,277.41,217.38,276.74,217Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,217a2.68,2.68,0,0,1-1.2-2.09c0-.77.54-1.08,1.2-.69a2.62,2.62,0,0,1,1.2,2.08C277.94,217.07,277.41,217.38,276.74,217Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,216a.79.79,0,0,1-.36-.62c0-.23.16-.32.36-.21a.79.79,0,0,1,.36.62C277.1,216,276.94,216.13,276.74,216Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,211.63a5.08,5.08,0,0,1-2.29-4c0-1.46,1-2,2.29-1.32a5.05,5.05,0,0,1,2.29,4C267.56,211.77,266.54,212.36,265.27,211.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,211.37a4.56,4.56,0,0,1-2.06-3.58c0-1.31.92-1.84,2.06-1.19a4.56,4.56,0,0,1,2.06,3.58C267.33,211.49,266.41,212,265.27,211.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,210.37a2.65,2.65,0,0,1-1.2-2.08c0-.77.54-1.08,1.2-.7a2.67,2.67,0,0,1,1.21,2.09C266.48,210.45,265.94,210.76,265.27,210.37Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,210.37a2.65,2.65,0,0,1-1.2-2.08c0-.77.54-1.08,1.2-.7a2.67,2.67,0,0,1,1.21,2.09C266.48,210.45,265.94,210.76,265.27,210.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,209.4a.79.79,0,0,1-.36-.62c0-.23.16-.32.36-.21a.79.79,0,0,1,.36.62C265.63,209.42,265.47,209.51,265.27,209.4Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.64,196.5a.65.65,0,0,1,.3.52c0,.19-.13.27-.3.17a.65.65,0,0,1-.3-.52C251.34,196.48,251.47,196.4,251.64,196.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2,218.3a.66.66,0,0,1,.3.52c0,.19-.13.27-.3.17a.66.66,0,0,1-.3-.52C289.9,218.28,290,218.21,290.2,218.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.64,206a.66.66,0,0,1,.3.52c0,.19-.13.27-.3.18a.66.66,0,0,1-.3-.52C251.34,206,251.47,205.87,251.64,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2,227.77a.63.63,0,0,1,.3.52c0,.19-.13.26-.3.17a.69.69,0,0,1-.3-.52C289.9,227.75,290,227.67,290.2,227.77Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--console--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M368.34,260.2l-12.84,7.41a2.54,2.54,0,0,1-2.31,0l-24.72-14.27a.7.7,0,0,1,0-1.33l12.84-7.42a2.58,2.58,0,0,1,2.3,0l24.73,14.28A.7.7,0,0,1,368.34,260.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--console--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.33,266.12l11.45-6.61a2.28,2.28,0,0,0,1-1.79v.14a2.28,2.28,0,0,0-1-1.79l-23-13.3a2.31,2.31,0,0,0-2.05,0l-11.46,6.62a2.26,2.26,0,0,0-1,1.78V251a2.28,2.28,0,0,0,1,1.78l23,13.3A2.27,2.27,0,0,0,355.33,266.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.31,248.87l12.48,7.2a2.28,2.28,0,0,1,1,1.79v-.14a2.28,2.28,0,0,1-1,1.79l-11.45,6.61a2.15,2.15,0,0,1-1,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,257.26l-11.45,6.62a2.33,2.33,0,0,1-2.06,0l-23-13.3a.63.63,0,0,1,0-1.19l11.46-6.62a2.31,2.31,0,0,1,2.05,0l23,13.3A.63.63,0,0,1,366.79,257.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,255.09v1.09l-11.89,6.87a1.11,1.11,0,0,1-.43.15,1.27,1.27,0,0,1-.76-.15L330.24,249.5v-1.14l23,13.34a2,2,0,0,0,1,.25,2.08,2.08,0,0,0,1-.25Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,255.09v1.09l-11.89,6.87a1.11,1.11,0,0,1-.43.15,1.27,1.27,0,0,1-.76-.15L330.24,249.5v-1.14l23,13.34a2,2,0,0,0,1,.25,2.08,2.08,0,0,0,1-.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,255.09v1.09l-11.89,6.87a1.11,1.11,0,0,1-.43.15h-.17V262a2.08,2.08,0,0,0,1-.25Z",
    style: {
      fill: "#FB923C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.34,261.7l11.45-6.61a2.28,2.28,0,0,0,1-1.78v-2.12a2.25,2.25,0,0,0-1-1.78l-23-13.3a2.25,2.25,0,0,0-2.05,0l-11.46,6.61a2.26,2.26,0,0,0-1,1.78v2.12a2.18,2.18,0,0,0,1,1.74l23,13.34A2.27,2.27,0,0,0,355.34,261.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.31,242.2l12.48,7.21a2.25,2.25,0,0,1,1,1.78v2.12a2.28,2.28,0,0,1-1,1.78l-11.45,6.61a2.18,2.18,0,0,1-1,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,250.59l-11.45,6.62a2.33,2.33,0,0,1-2.06,0l-23-13.3a.63.63,0,0,1,0-1.19l11.46-6.61a2.25,2.25,0,0,1,2.05,0l23,13.3A.62.62,0,0,1,366.79,250.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.81,245.34c1.27.73,1.27,1.91,0,2.64a5.08,5.08,0,0,1-4.59,0c-1.27-.73-1.27-1.91,0-2.64A5,5,0,0,1,350.81,245.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.11,246.11a.9.9,0,0,1,.4.7c0,.26-.18.37-.4.24a.88.88,0,0,1-.4-.7C331.71,246.09,331.89,246,332.11,246.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.11,247.66a.9.9,0,0,1,.4.7c0,.26-.18.37-.4.25a.9.9,0,0,1-.4-.7C331.71,247.65,331.89,247.54,332.11,247.66Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.14,176.08a1.88,1.88,0,0,1,1.1-1.54L266.5,153a5.91,5.91,0,0,1,5.34,0l141.62,81.76a1.88,1.88,0,0,1,1.1,1.55v2.89a1.85,1.85,0,0,1-1.1,1.54L376.2,262.29a5.91,5.91,0,0,1-5.34,0L229.24,180.52a1.84,1.84,0,0,1-1.1-1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.2,259.39l37.26-21.51c1.48-.85,1.48-2.23,0-3.09L271.84,153a5.91,5.91,0,0,0-5.34,0l-37.26,21.51c-1.48.85-1.48,2.23,0,3.09l141.62,81.76A5.91,5.91,0,0,0,376.2,259.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,153l-22.73,13.26-11.38,6.6-2.85,1.65a2.47,2.47,0,0,0-1.13,1,1.21,1.21,0,0,0,.22,1.36,4.53,4.53,0,0,0,1.29.91l1.43.82,2.85,1.64,45.62,26.24,45.54,26.39,22.77,13.2,22.73,13.26-22.85-13-22.82-13.12L279.57,207,234,180.59l-2.84-1.65-1.42-.83a5,5,0,0,1-1.38-1,1.53,1.53,0,0,1-.26-1.69,2.82,2.82,0,0,1,1.26-1.16l2.85-1.64,11.41-6.56Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tv--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.35,239.1l-147-84.85-14.11,8.15,52,30c1.79,1,1.79,2.71,0,3.74L298,198.6c-1.79,1-1.79,2.71,0,3.75L330.27,221a7.18,7.18,0,0,0,6.48,0l4.28-2.43a7.18,7.18,0,0,1,6.48,0l49.72,28.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,162.16l22.88,13.22A4.32,4.32,0,0,1,341,178l5.68,32.2a2.72,2.72,0,0,1-1.23,2.64l-10.3,5.9a3.35,3.35,0,0,1-3.08,0L300.5,200.55a2.89,2.89,0,0,1,0-5.1l6.89-3.94a3.9,3.9,0,0,0,1.72-2.66l2.52-24.14a3.77,3.77,0,0,1,1.63-2.6A3.3,3.3,0,0,1,316.24,162.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,162.16l22.88,13.22A4.32,4.32,0,0,1,341,178l5.68,32.2a2.72,2.72,0,0,1-1.23,2.64l-10.3,5.9a3.35,3.35,0,0,1-3.08,0L300.5,200.55a2.89,2.89,0,0,1,0-5.1l6.89-3.94a3.9,3.9,0,0,0,1.72-2.66l2.52-24.14a3.77,3.77,0,0,1,1.63-2.6A3.3,3.3,0,0,1,316.24,162.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.58,213v6.14a3.13,3.13,0,0,1-1.54-.37L300.5,200.55A3.28,3.28,0,0,1,299,198a3,3,0,0,1,.6-1.66h5.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.35,163.83,336.24,177a4.3,4.3,0,0,1,1.84,2.64l5.16,29.18a2.71,2.71,0,0,1-1.23,2.63l-6.89,3.94a3.41,3.41,0,0,1-3.08,0L300.5,197.22a.93.93,0,0,1,0-1.77l6.89-3.94a3.9,3.9,0,0,0,1.72-2.66l2.52-24.14A1.06,1.06,0,0,1,313.35,163.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.35,163.83a1.06,1.06,0,0,0-1.72.88l-2.27,21.77,33.33,19.24-4.61-26a4.3,4.3,0,0,0-1.84-2.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,195.45l6.89-3.94a3.58,3.58,0,0,0,1.13-1.13L343,210.31a2.63,2.63,0,0,1-1,1.18l-6.89,3.94a3.41,3.41,0,0,1-3.08,0L300.5,197.22A.93.93,0,0,1,300.5,195.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61,241.84l.32-.19a4.73,4.73,0,0,0,2.15-3.73V114.45a4.75,4.75,0,0,0-2.15-3.73L251.6,16.23a4.78,4.78,0,0,0-4.31,0l0,0A4.76,4.76,0,0,0,245.17,20V143.43a4.76,4.76,0,0,0,2.15,3.73l164,94.68A4.79,4.79,0,0,0,415.61,241.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.58,116.3l6.87-4a4.36,4.36,0,0,1,.63,2.12V237.92a4.73,4.73,0,0,1-2.15,3.73l-.32.19a4.79,4.79,0,0,1-4.3,0l-.73-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.46,240.59V117.12a4.75,4.75,0,0,0-2.15-3.73l-164-94.68c-1.19-.69-2.15-.13-2.15,1.24V143.43a4.76,4.76,0,0,0,2.15,3.73l164,94.68C412.5,242.52,413.46,242,413.46,240.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.17,20l.28,39.67.16,39.66.09,39.66v3.72a8.46,8.46,0,0,0,0,1.16,4.37,4.37,0,0,0,.89,2,3.42,3.42,0,0,0,.77.75c.26.18.69.4,1,.6l8.6,5L274.2,162l68.64,39.78,34.27,20,34.2,20.09-34.5-19.58-34.43-19.69L273.62,163l-17.16-9.94-8.58-5c-.38-.23-.68-.38-1.11-.66a4.65,4.65,0,0,1-1-1,5.41,5.41,0,0,1-1.1-2.49,12.35,12.35,0,0,1,0-1.32v-3.72l.09-39.66.16-39.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,188.89l-6.34-3.66c-.47-.27-.86-.08-.86.43a1.85,1.85,0,0,0,.86,1.43l6.34,3.66c.47.27.85.08.85-.44A1.83,1.83,0,0,0,328.09,188.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,116.39l-157-90.83c-.68-.4-1.23-.08-1.23.71V137.12a2.72,2.72,0,0,0,1.23,2.13L408,229.9c.68.39,1.23.08,1.23-.71V118.53A2.74,2.74,0,0,0,408,116.39Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,116.39l-157-90.83c-.68-.4-1.23-.08-1.23.71V137.12a2.72,2.72,0,0,0,1.23,2.13L408,229.9c.68.39,1.23.08,1.23-.71V118.53A2.74,2.74,0,0,0,408,116.39Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.46 127.73 294.94 51.01 329.46 71.19 329.46 127.73",
    style: {
      fill: "#FB923C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.46 76.01 329.69 88.95 329.82 101.89 329.93 127.76 329.82 153.64 329.69 166.57 329.46 179.51 329.24 166.57 329.1 153.64 329 127.76 329.11 101.89 329.24 88.95 329.46 76.01",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.14 82.54 270.89 93.54 290.57 104.68 329.82 127.14 368.9 149.9 388.38 161.37 407.79 172.98 388.03 161.98 368.35 150.85 329.11 128.38 290.03 105.62 270.55 94.14 251.14 82.54",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.87,172.71a19.47,19.47,0,0,1-9.66-2.9c-14.91-8.6-27-34.25-27-57.16,0-13.29,4-23.23,11-27.26,4.83-2.79,10.56-2.42,16.56,1,14.92,8.61,27.05,34.25,27.05,57.16,0,13.29-4,23.23-11,27.26A13.64,13.64,0,0,1,338.87,172.71ZM320.06,84.54a12.58,12.58,0,0,0-6.41,1.72c-6.56,3.79-10.48,13.66-10.48,26.39,0,22.59,11.91,47.85,26.54,56.3,5.69,3.28,11.07,3.64,15.57,1,6.56-3.79,10.48-13.66,10.48-26.39,0-22.59-11.91-47.85-26.55-56.3A18.49,18.49,0,0,0,320.06,84.54Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.33,165.41a16.31,16.31,0,0,1-8.08-2.42c-12.47-7.2-22.61-28.65-22.61-47.8,0-11.12,3.34-19.43,9.18-22.8,4-2.34,8.83-2,13.85.87,12.48,7.2,22.62,28.65,22.62,47.8,0,11.12-3.35,19.43-9.18,22.8A11.39,11.39,0,0,1,337.33,165.41ZM321.6,91.68a10.65,10.65,0,0,0-5.36,1.43c-5.49,3.17-8.77,11.42-8.77,22.08,0,18.89,10,40,22.2,47.08,4.75,2.74,9.25,3,13,.87,5.49-3.17,8.77-11.42,8.77-22.08,0-18.89-10-40-22.21-47.08A15.44,15.44,0,0,0,321.6,91.68Z",
    style: {
      fill: "#FB923C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323,108.8a1,1,0,0,1,.25-.77.45.45,0,0,1,.6,0l11.77,6.79a1.67,1.67,0,0,1,.6.73,2.6,2.6,0,0,1,.25,1.06V120a1.06,1.06,0,0,1-.25.77.47.47,0,0,1-.6,0l-8.8-5.08-.34,6a3.55,3.55,0,0,1,1.67.34c.56.26,1,.49,1.36.69a14.45,14.45,0,0,1,3.26,2.6,16.82,16.82,0,0,1,2.6,3.65,20.53,20.53,0,0,1,2.35,9.62,15.41,15.41,0,0,1-.64,4.91,5.22,5.22,0,0,1-1.76,2.61,3.52,3.52,0,0,1-2.61.56,9.06,9.06,0,0,1-3.2-1.2,15.94,15.94,0,0,1-3.71-2.91,16.55,16.55,0,0,1-2.56-3.58,17.83,17.83,0,0,1-1.54-3.92,18.31,18.31,0,0,1-.58-3.93.91.91,0,0,1,.24-.8.51.51,0,0,1,.61,0l2.53,1.46a1.65,1.65,0,0,1,.57.64,3.44,3.44,0,0,1,.34,1,9,9,0,0,0,.6,2.16,8.17,8.17,0,0,0,.94,1.65,6.38,6.38,0,0,0,1.19,1.24,10.71,10.71,0,0,0,1.37.94c1.19.69,2.15.74,2.89.17s1.09-1.73,1.09-3.47a9,9,0,0,0-1.09-4.25,8,8,0,0,0-2.89-3.15,4.68,4.68,0,0,0-1.48-.64,2,2,0,0,0-.89,0c-.24.06-.44.11-.63.14a1.07,1.07,0,0,1-.72-.2L323,126.39a1.62,1.62,0,0,1-.6-.73,2.57,2.57,0,0,1-.25-1.06Z",
    style: {
      fill: "#FB923C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M362.61,235.8l-12.24,7.06a.74.74,0,0,0,0,1.39l12.45,7.19a2.67,2.67,0,0,0,2.4,0l12.24-7.07a.74.74,0,0,0,0-1.39L365,235.8A2.61,2.61,0,0,0,362.61,235.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.47,222.19l11.16,6.45a2.4,2.4,0,0,1,1.09,1.89v13.1a2.43,2.43,0,0,1-1.09,1.9l-8.08,4.66a2.42,2.42,0,0,1-2.19,0l-11.15-6.44a2.41,2.41,0,0,1-1.1-1.89V228.75a2.41,2.41,0,0,1,1.1-1.89l8.07-4.67A2.48,2.48,0,0,1,362.47,222.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.36,234.56l-11.15-6.44c-.61-.35-1.1-.06-1.1.63v13.11a2.41,2.41,0,0,0,1.1,1.89l11.15,6.44c.61.35,1.1.07,1.1-.63v-13.1A2.42,2.42,0,0,0,363.36,234.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.55,234.56l8.08-4.66c.6-.35,1.09-.07,1.09.63v13.1a2.43,2.43,0,0,1-1.09,1.9l-8.08,4.66c-.6.35-1.09.07-1.09-.63v-13.1A2.43,2.43,0,0,1,365.55,234.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.28,222.19l-8.07,4.67a.66.66,0,0,0,0,1.26l11.15,6.44a2.42,2.42,0,0,0,2.19,0l8.08-4.66a.67.67,0,0,0,0-1.26l-11.16-6.45A2.48,2.48,0,0,0,360.28,222.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,244.57a10.15,10.15,0,0,1-4.59-8c0-2.93,2.06-4.11,4.59-2.65a10.17,10.17,0,0,1,4.6,8C362.38,244.85,360.32,246,357.78,244.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,244a9.14,9.14,0,0,1-4.13-7.16c0-2.64,1.85-3.71,4.13-2.39a9.14,9.14,0,0,1,4.14,7.17C361.92,244.29,360.07,245.36,357.78,244Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,242.06a5.36,5.36,0,0,1-2.41-4.19c0-1.54,1.08-2.16,2.41-1.39a5.32,5.32,0,0,1,2.42,4.18C360.2,242.2,359.12,242.83,357.78,242.06Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,242.06a5.36,5.36,0,0,1-2.41-4.19c0-1.54,1.08-2.16,2.41-1.39a5.32,5.32,0,0,1,2.42,4.18C360.2,242.2,359.12,242.83,357.78,242.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,240.1a1.61,1.61,0,0,1-.71-1.25c0-.45.32-.64.71-.41a1.57,1.57,0,0,1,.72,1.24C358.5,240.14,358.18,240.32,357.78,240.1Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.31,229.37a.86.86,0,0,1,.39.67c0,.25-.18.35-.39.23a.86.86,0,0,1-.39-.68C351.92,229.34,352.09,229.24,352.31,229.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,235.57a.83.83,0,0,1,.39.67c0,.25-.17.35-.39.23a.86.86,0,0,1-.39-.68C362.65,235.54,362.82,235.44,363,235.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.31,241.72a.88.88,0,0,1,.39.68c0,.25-.18.35-.39.22a.85.85,0,0,1-.39-.68C351.92,241.69,352.09,241.59,352.31,241.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,247.92a.85.85,0,0,1,.39.67c0,.25-.17.36-.39.23a.85.85,0,0,1-.39-.68C362.65,247.89,362.82,247.79,363,247.92Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M260.6,176.77l-12.24,7.07a.73.73,0,0,0,0,1.38l12.45,7.19a2.67,2.67,0,0,0,2.4,0l12.24-7.06a.74.74,0,0,0,0-1.39L263,176.77A2.67,2.67,0,0,0,260.6,176.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.05,163.06l11.15,6.44a2.42,2.42,0,0,1,1.1,1.9v13.1a2.38,2.38,0,0,1-1.1,1.89l-8.08,4.67a2.39,2.39,0,0,1-2.18,0l-11.16-6.44a2.43,2.43,0,0,1-1.09-1.9v-13.1a2.43,2.43,0,0,1,1.09-1.9l8.08-4.66A2.42,2.42,0,0,1,260.05,163.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,175.43,249.78,169c-.6-.35-1.09-.07-1.09.63v13.1a2.43,2.43,0,0,0,1.09,1.9l11.16,6.44c.6.35,1.09.06,1.09-.63V177.32A2.41,2.41,0,0,0,260.94,175.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.12,175.43l8.08-4.67c.61-.35,1.1-.06,1.1.64v13.1a2.38,2.38,0,0,1-1.1,1.89l-8.08,4.67c-.6.35-1.09.06-1.09-.63V177.32A2.41,2.41,0,0,1,263.12,175.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,163.06l-8.08,4.66a.67.67,0,0,0,0,1.27l11.16,6.44a2.39,2.39,0,0,0,2.18,0l8.08-4.67a.66.66,0,0,0,0-1.26l-11.15-6.44A2.42,2.42,0,0,0,257.86,163.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.36,185.44a10.17,10.17,0,0,1-4.6-8c0-2.93,2.06-4.12,4.6-2.65a10.12,10.12,0,0,1,4.59,8C260,185.72,257.9,186.9,255.36,185.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.36,184.91a9.14,9.14,0,0,1-4.14-7.17c0-2.63,1.85-3.7,4.14-2.38a9.14,9.14,0,0,1,4.13,7.16C259.49,185.16,257.64,186.23,255.36,184.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.36,182.92a5.32,5.32,0,0,1-2.42-4.18c0-1.54,1.08-2.16,2.42-1.4a5.36,5.36,0,0,1,2.41,4.19C257.77,183.07,256.69,183.69,255.36,182.92Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.36,182.92a5.32,5.32,0,0,1-2.42-4.18c0-1.54,1.08-2.16,2.42-1.4a5.36,5.36,0,0,1,2.41,4.19C257.77,183.07,256.69,183.69,255.36,182.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.36,181a1.57,1.57,0,0,1-.72-1.24c0-.46.32-.64.72-.42a1.61,1.61,0,0,1,.71,1.25C256.07,181,255.75,181.19,255.36,181Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88,170.23a.85.85,0,0,1,.39.68c0,.25-.17.35-.39.22a.83.83,0,0,1-.39-.67C249.49,170.21,249.66,170.11,249.88,170.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.61,176.43a.85.85,0,0,1,.39.68c0,.25-.17.35-.39.22a.87.87,0,0,1-.39-.67C260.22,176.41,260.4,176.3,260.61,176.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88,182.58a.86.86,0,0,1,.39.68c0,.25-.17.35-.39.23a.86.86,0,0,1-.39-.68C249.49,182.56,249.66,182.46,249.88,182.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.61,188.78a.86.86,0,0,1,.39.68c0,.25-.17.35-.39.22a.86.86,0,0,1-.39-.67C260.22,188.76,260.4,188.66,260.61,188.78Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker-1--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M433.85,299.69l-20.84,12c-1.33.76-1.33,2,0,2.77l24.87,14.36a5.34,5.34,0,0,0,4.8,0l20.83-12c1.33-.76,1.33-2,0-2.77l-24.87-14.36A5.32,5.32,0,0,0,433.85,299.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.1,313.85a1.34,1.34,0,0,0-.8-1.11l-20.45-11.81a4.28,4.28,0,0,0-3.85,0l-14.21,8.21a1.34,1.34,0,0,0-.79,1.11v2.26a1.35,1.35,0,0,0,.79,1.11l20.46,11.81a4.28,4.28,0,0,0,3.85,0l14.2-8.2a1.36,1.36,0,0,0,.8-1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,300.93l-14.21,8.21a1.17,1.17,0,0,0,0,2.22l20.46,11.81a4.28,4.28,0,0,0,3.85,0l14.2-8.2a1.18,1.18,0,0,0,0-2.23l-20.45-11.81A4.28,4.28,0,0,0,435,300.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,300.93q-4.58,2.81-9.19,5.53l-4.62,2.71a1.86,1.86,0,0,0-.89.77.81.81,0,0,0,.25.95,7.31,7.31,0,0,0,1.09.67l1.16.67,9.26,5.41q4.6,2.73,9.19,5.53c-3.15-1.71-6.27-3.44-9.39-5.2l-9.31-5.31-1.16-.67a6.82,6.82,0,0,1-1.17-.76,1.26,1.26,0,0,1-.34-1.48,2.23,2.23,0,0,1,1.08-1l4.66-2.65Q430.29,303.49,435,300.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.73 285.36 437.61 280.67 435.12 282.11 435.12 310.25 443.24 314.94 445.73 313.5 445.73 285.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.12 310.25 435.12 282.11 443.24 286.8 443.24 314.94 435.12 310.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12,282.1v13.84l5.48,3.17a3.94,3.94,0,0,0,3.57,0l1.56-.9V285.36l-8.12-4.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.15,208.83l18.18,10.5a3.92,3.92,0,0,1,1.79,3.09V285a3.94,3.94,0,0,1-1.79,3.09l-13.16,7.6a3.94,3.94,0,0,1-3.57,0l-18.18-10.5a3.92,3.92,0,0,1-1.79-3.09V219.52a3.94,3.94,0,0,1,1.79-3.09l13.16-7.6A3.94,3.94,0,0,1,439.15,208.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.6,229l-18.18-10.5c-1-.57-1.79-.11-1.79,1v62.57a3.92,3.92,0,0,0,1.79,3.09l18.18,10.5c1,.57,1.78.11,1.78-1V232.08A3.92,3.92,0,0,0,440.6,229Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.63,219.52l.12,23.89,0,9.06.07,18.11,0,9.05v2.27a3.52,3.52,0,0,0,.59,2,3.7,3.7,0,0,0,.7.82,5.68,5.68,0,0,0,.93.59l1.95,1.14,7.83,4.57,7.78,4.62-7.9-4.43-7.86-4.49-2-1.12a6.64,6.64,0,0,1-1-.62,4.08,4.08,0,0,1-.77-.89,3.92,3.92,0,0,1-.67-2.23v-2.27l0-9.05.08-18.11,0-9.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.17,229l13.16-7.6c1-.57,1.79-.11,1.79,1V285a3.94,3.94,0,0,1-1.79,3.09l-13.16,7.6c-1,.57-1.79.11-1.79-1V232.08A3.94,3.94,0,0,1,444.17,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.58,208.83l-13.16,7.6a1.09,1.09,0,0,0,0,2.06L440.6,229a3.94,3.94,0,0,0,3.57,0l13.16-7.6a1.09,1.09,0,0,0,0-2.06l-18.18-10.5A3.94,3.94,0,0,0,435.58,208.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,262.66a16.56,16.56,0,0,1-7.49-13c0-4.77,3.35-6.71,7.49-4.32a16.55,16.55,0,0,1,7.49,13C439,263.11,435.65,265.05,431.51,262.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,261.79a14.91,14.91,0,0,1-6.74-11.67c0-4.3,3-6,6.74-3.89a14.88,14.88,0,0,1,6.74,11.67C438.25,262.2,435.23,263.94,431.51,261.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,258.55a8.69,8.69,0,0,1-3.94-6.81c0-2.51,1.77-3.53,3.94-2.28a8.72,8.72,0,0,1,3.93,6.82C435.44,258.79,433.68,259.81,431.51,258.55Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,258.55a8.69,8.69,0,0,1-3.94-6.81c0-2.51,1.77-3.53,3.94-2.28a8.72,8.72,0,0,1,3.93,6.82C435.44,258.79,433.68,259.81,431.51,258.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,255.36a2.59,2.59,0,0,1-1.17-2c0-.74.52-1,1.17-.67a2.6,2.6,0,0,1,1.17,2C432.68,255.43,432.15,255.73,431.51,255.36Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,240.86a10.11,10.11,0,0,1-4.58-7.92c0-2.92,2.05-4.1,4.58-2.64a10.12,10.12,0,0,1,4.57,7.92C436.08,241.14,434,242.32,431.51,240.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,240.33a9.1,9.1,0,0,1-4.12-7.13c0-2.62,1.85-3.69,4.12-2.37a9.09,9.09,0,0,1,4.11,7.12C435.62,240.58,433.78,241.64,431.51,240.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,238.35a5.29,5.29,0,0,1-2.4-4.16c0-1.53,1.07-2.15,2.4-1.39a5.31,5.31,0,0,1,2.4,4.17C433.91,238.5,432.84,239.12,431.51,238.35Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,238.35a5.29,5.29,0,0,1-2.4-4.16c0-1.53,1.07-2.15,2.4-1.39a5.31,5.31,0,0,1,2.4,4.17C433.91,238.5,432.84,239.12,431.51,238.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,236.4a1.56,1.56,0,0,1-.71-1.23c0-.46.31-.64.71-.42a1.6,1.6,0,0,1,.71,1.24C432.22,236.45,431.9,236.63,431.51,236.4Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,284.23a16.55,16.55,0,0,1-7.49-13c0-4.78,3.35-6.72,7.49-4.33a16.56,16.56,0,0,1,7.49,13C439,284.68,435.65,286.62,431.51,284.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,283.37a14.91,14.91,0,0,1-6.74-11.68c0-4.3,3-6,6.74-3.89a14.91,14.91,0,0,1,6.74,11.67C438.25,283.77,435.23,285.51,431.51,283.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,280.13a8.73,8.73,0,0,1-3.94-6.82c0-2.51,1.77-3.53,3.94-2.27a8.68,8.68,0,0,1,3.93,6.81C435.44,280.36,433.68,281.38,431.51,280.13Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,280.13a8.73,8.73,0,0,1-3.94-6.82c0-2.51,1.77-3.53,3.94-2.27a8.68,8.68,0,0,1,3.93,6.81C435.44,280.36,433.68,281.38,431.51,280.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,276.93a2.57,2.57,0,0,1-1.17-2c0-.75.52-1.05,1.17-.68a2.61,2.61,0,0,1,1.17,2C432.68,277,432.15,277.3,431.51,276.93Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.58,220.52a1.4,1.4,0,0,1,.64,1.1c0,.41-.29.57-.64.37a1.42,1.42,0,0,1-.64-1.11C421.94,220.48,422.23,220.31,422.58,220.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07,230.62a1.39,1.39,0,0,1,.64,1.1c0,.41-.28.58-.64.37a1.4,1.4,0,0,1-.63-1.1C439.44,230.58,439.72,230.42,440.07,230.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.58,281.87a1.41,1.41,0,0,1,.64,1.1c0,.41-.29.57-.64.37a1.41,1.41,0,0,1-.64-1.1C421.94,281.83,422.23,281.67,422.58,281.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07,292a1.41,1.41,0,0,1,.64,1.11c0,.4-.28.57-.64.37a1.42,1.42,0,0,1-.63-1.11C439.44,291.93,439.72,291.77,440.07,292Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-40"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M276.22,428.87c.86-.49.86-1.29,0-1.79L116.64,334.75a3.45,3.45,0,0,0-3.1,0L31.34,359c8.82,22.64,21.44,42.33,37.89,56.75,36.3,31.8,79.86,58.1,156.8,63.32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M276.43,400.21,220.1,367.68c-2.39-1.38-2.39-3.62,0-5l56.33-32.52a9.57,9.57,0,0,1,8.66,0l56.34,32.52c2.39,1.38,2.39,3.62,0,5l-56.34,32.53A9.57,9.57,0,0,1,276.43,400.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ottoman--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "274.44 375.33 277.64 391.25 280.76 393.05 283.85 391.27 287.09 375.33 280.76 371.68 274.44 375.33",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.76 393.05 280.76 378.99 274.44 375.33 277.64 391.25 280.76 393.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.44 375.33 276.51 385.61 280.76 388.07 285 385.63 287.09 375.33 280.76 371.68 274.44 375.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.67 349.49 232.88 365.41 236 367.21 239.09 365.42 242.32 349.49 236 345.83 229.67 349.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236 367.21 236 353.14 229.67 349.49 232.88 365.41 236 367.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.67 349.49 231.74 359.77 236 362.23 240.24 359.78 242.32 349.49 236 345.83 229.67 349.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.2 349.49 322.41 365.41 325.53 367.21 328.62 365.42 331.86 349.49 325.53 345.83 319.2 349.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.53 367.21 325.53 353.14 319.2 349.49 322.41 365.41 325.53 367.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.2 349.49 321.27 359.77 325.53 362.23 329.77 359.78 331.86 349.49 325.53 345.83 319.2 349.49",
    style: {
      opacity: 0.2
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.83,310.38l-52.09,30.06a7.55,7.55,0,0,0-3.41,5.91V349a7.55,7.55,0,0,0,3.41,5.91l50.75,29.29a7.52,7.52,0,0,0,6.82,0l52.07-30.06a7.52,7.52,0,0,0,3.41-5.91v-2.61a7.5,7.5,0,0,0-3.41-5.9l-50.74-29.3A7.5,7.5,0,0,0,278.83,310.38Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.38,339.68l-50.74-29.3a7.5,7.5,0,0,0-6.81,0l-52.09,30.06c-1.88,1.09-1.89,2.85,0,3.94l50.75,29.3a7.52,7.52,0,0,0,6.82,0l52.07-30.07C338.27,342.53,338.27,340.76,336.38,339.68Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223.33,349v-2.61c0-2.18,1.52-3.06,3.41-2l50.75,29.3a7.55,7.55,0,0,1,3.41,5.91v2.61c0,2.17-1.53,3.05-3.41,2l-50.75-29.29A7.55,7.55,0,0,1,223.33,349Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,382.2v-2.61a7.55,7.55,0,0,1,3.41-5.91l52.07-30.07c1.89-1.08,3.41-.2,3.41,2v2.61a7.52,7.52,0,0,1-3.41,5.91l-52.07,30.06C282.43,385.25,280.9,384.37,280.9,382.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.83,290.19l-52.09,30.06a7.55,7.55,0,0,0-3.41,5.91V337a7.55,7.55,0,0,0,3.41,5.9l50.75,29.3a7.58,7.58,0,0,0,6.82,0l52.07-30.07a7.52,7.52,0,0,0,3.41-5.91V325.39a7.5,7.5,0,0,0-3.41-5.9l-50.74-29.3A7.5,7.5,0,0,0,278.83,290.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.16,320.62c-6.09-1.07-10.41-2.63-17.65-3a234.48,234.48,0,0,0-33.47.33c-11.26.77-18.72,2-23.23,4.15a7.3,7.3,0,0,0-1.48,4.1v2.44c10.15,6.38,35,21.73,37.68,20.89,3.33-1.07,19.77-10.78,26.08-15.79s10.94-2.07,15.73-4.58S305.24,321.69,299.16,320.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,337V326.16c0-2.18,1.52-3.06,3.41-2l50.75,29.3a7.55,7.55,0,0,1,3.41,5.91v10.83c0,2.17-1.53,3-3.41,2l-50.75-29.3A7.55,7.55,0,0,1,223.33,337Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,337V326.16c0-2.18,1.52-3.06,3.41-2l50.75,29.3a7.55,7.55,0,0,1,3.41,5.91v10.83c0,2.17-1.53,3-3.41,2l-50.75-29.3A7.55,7.55,0,0,1,223.33,337Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,370.23V359.4a7.55,7.55,0,0,1,3.41-5.91l52.07-30.07c1.89-1.08,3.41-.2,3.41,2v10.83a7.52,7.52,0,0,1-3.41,5.91L284.31,372.2C282.43,373.28,280.9,372.4,280.9,370.23Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.21 357.45 74.46 376.04 70.82 378.14 67.21 376.06 63.43 357.45 70.82 353.18 78.21 357.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.82 378.14 70.82 361.72 78.21 357.45 74.46 376.04 70.82 378.14",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.21 357.45 75.79 369.46 70.82 372.33 65.87 369.47 63.43 357.45 70.82 353.18 78.21 357.45",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.8 329.4 123.05 347.99 119.41 350.09 115.8 348.01 112.02 329.4 119.41 325.13 126.8 329.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.41 350.09 119.41 333.66 126.8 329.4 123.05 347.99 119.41 350.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.8 329.4 124.38 341.4 119.41 344.27 114.46 341.42 112.02 329.4 119.41 325.13 126.8 329.4",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,258.71c-2.8-1.6-6.73-1.32-11.17,1.25l-55.08,31.8a7.85,7.85,0,0,0-3.55,7.44l9.36,58.86a3.58,3.58,0,0,0,1.61,2.64L70,367.75a3.42,3.42,0,0,0,3.48-.22l52.27-30.17a10.31,10.31,0,0,0,4.59-7.5l2.8-53.37c.28-5.31-1.38-9-4.27-10.71C126.69,264.54,118.71,259.94,116.57,258.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.83,367.67c-1.39-.79-11.16-6.43-12.09-7a3.58,3.58,0,0,1-1.61-2.64l-9.36-58.87a7.29,7.29,0,0,1,.6-3.94l12.19,7a7.33,7.33,0,0,0-.6,4l9.36,58.86A3.61,3.61,0,0,0,69.83,367.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.83,367.67c-1.39-.79-11.16-6.43-12.09-7a3.58,3.58,0,0,1-1.61-2.64l-9.36-58.87a7.29,7.29,0,0,1,.6-3.94l12.19,7a7.33,7.33,0,0,0-.6,4l9.36,58.86A3.61,3.61,0,0,0,69.83,367.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.31,365.1,59,306.23a7.85,7.85,0,0,1,3.55-7.44L117.59,267c9.07-5.24,16-1,15.5,9.5l-2.8,53.37a10.31,10.31,0,0,1-4.59,7.5L73.43,367.53C71.05,368.91,68.75,367.81,68.31,365.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73,305.93l51.81,29.9a8.8,8.8,0,0,1,4,6.89v12.67a8.78,8.78,0,0,1-4,6.89L138.26,396.5a8.79,8.79,0,0,1-8,0L78.51,366.59a8.79,8.79,0,0,1-4-6.89V347.05a8.81,8.81,0,0,1,4-6.9l59.26-34.22A8.82,8.82,0,0,1,145.73,305.93Z",
    style: {
      fill: "#455a64"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.51,340.15l59.26-34.22a8.82,8.82,0,0,1,8,0l51.81,29.9c2.2,1.27,2.2,3.33,0,4.6l-59.28,34.22a8.79,8.79,0,0,1-8,0l-51.79-29.9C76.31,343.48,76.31,341.42,78.51,340.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,355.39V342.72c0-2.53-1.78-3.56-4-2.29l-59.28,34.22a8.8,8.8,0,0,0-4,6.9V394.2c0,2.54,1.78,3.57,4,2.3l59.28-34.22A8.78,8.78,0,0,0,201.52,355.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28,394.2V381.55a8.8,8.8,0,0,0-4-6.9l-51.79-29.9c-2.2-1.27-4-.24-4,2.3V359.7a8.79,8.79,0,0,0,4,6.89L130.3,396.5C132.5,397.77,134.28,396.74,134.28,394.2Z",
    style: {
      fill: "#37474f"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.73,282.35l51.81,29.9a8.78,8.78,0,0,1,4,6.89v12.67a8.8,8.8,0,0,1-4,6.89l-59.28,34.22a8.79,8.79,0,0,1-8,0L78.51,343a8.79,8.79,0,0,1-4-6.89V323.46a8.81,8.81,0,0,1,4-6.89l59.26-34.22A8.79,8.79,0,0,1,145.73,282.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,316.57l59.26-34.22a8.79,8.79,0,0,1,8,0l51.81,29.9c2.2,1.27,2.2,3.33,0,4.59l-59.28,34.23a8.79,8.79,0,0,1-8,0l-51.79-29.9C76.31,319.9,76.31,317.84,78.51,316.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,331.81V319.14c0-2.54-1.78-3.56-4-2.3l-59.28,34.23a8.8,8.8,0,0,0-4,6.89v12.66c0,2.54,1.78,3.57,4,2.3l59.28-34.22A8.8,8.8,0,0,0,201.52,331.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28,370.62V358a8.8,8.8,0,0,0-4-6.89l-51.79-29.9c-2.2-1.27-4-.24-4,2.29v12.66a8.79,8.79,0,0,0,4,6.89l51.79,29.91C132.5,374.19,134.28,373.16,134.28,370.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,342.45l51.81,29.89a8.8,8.8,0,0,1,4,6.9V391.9a8.77,8.77,0,0,1-4,6.89L201.5,433a8.79,8.79,0,0,1-8,0l-51.79-29.9a8.8,8.8,0,0,1-4-6.9V383.56a8.8,8.8,0,0,1,4-6.9L201,342.45A8.79,8.79,0,0,1,209,342.45Z",
    style: {
      fill: "#455a64"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.75,376.66,201,342.45a8.79,8.79,0,0,1,8,0l51.81,29.89c2.2,1.27,2.2,3.33,0,4.6L201.5,411.16a8.79,8.79,0,0,1-8,0l-51.79-29.9C139.55,380,139.55,377.93,141.75,376.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.76,391.9V379.24c0-2.54-1.78-3.57-4-2.3L201.5,411.16a8.8,8.8,0,0,0-4,6.9v12.65c0,2.54,1.78,3.57,4,2.3l59.28-34.22A8.77,8.77,0,0,0,264.76,391.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.52,430.71V418.06a8.8,8.8,0,0,0-4-6.9l-51.79-29.9c-2.2-1.27-4-.24-4,2.3v12.65a8.8,8.8,0,0,0,4,6.9L193.54,433C195.74,434.28,197.52,433.25,197.52,430.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,318.87l51.81,29.89a8.8,8.8,0,0,1,4,6.9v12.66a8.78,8.78,0,0,1-4,6.89L201.5,409.43a8.79,8.79,0,0,1-8,0l-51.79-29.9a8.8,8.8,0,0,1-4-6.9V360a8.8,8.8,0,0,1,4-6.9L201,318.87A8.79,8.79,0,0,1,209,318.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,353.08,201,318.87a8.79,8.79,0,0,1,8,0l51.81,29.89c2.2,1.27,2.2,3.33,0,4.6L201.5,387.58a8.79,8.79,0,0,1-8,0l-51.79-29.9C139.55,356.41,139.55,354.35,141.75,353.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.76,368.32V355.66c0-2.54-1.78-3.57-4-2.3L201.5,387.58a8.8,8.8,0,0,0-4,6.9v12.65c0,2.54,1.78,3.57,4,2.3l59.28-34.22A8.78,8.78,0,0,0,264.76,368.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.52,407.13V394.48a8.8,8.8,0,0,0-4-6.9l-51.79-29.9c-2.2-1.27-4-.24-4,2.3v12.65a8.8,8.8,0,0,0,4,6.9l51.79,29.9C195.74,410.7,197.52,409.67,197.52,407.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.94,313.28c-1,10.1-2.48,18.47,10.12,26.36s23,8.5,30,6.3S174.58,327,174.58,327l-17.17-13.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.94,272.57c-4.23,6.18-9.76,16.26-10.86,19.5s-1.9,6.73,4.15,9.19,16.4,1.71,16.4,1.71l1.87-26.67Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.94,272.57c-4.23,6.18-9.76,16.26-10.86,19.5s-1.9,6.73,4.15,9.19,16.4,1.71,16.4,1.71l1.87-26.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,258.23c-8.61-1.88-13.38-.63-19,7.76A126.45,126.45,0,0,0,103,280s3.15,8.16,11.85,7.6C120,288.05,130.08,258.23,130.08,258.23Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,258.23c-8.61-1.88-13.38-.63-19,7.76A126.45,126.45,0,0,0,103,280s3.15,8.16,11.85,7.6C120,288.05,130.08,258.23,130.08,258.23Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63,272.28c-.48-6.52-1-12.85-1-12.85a40.15,40.15,0,0,0-6.81.23,23.27,23.27,0,0,0-5.79,6.33A126.45,126.45,0,0,0,103,280s3.15,8.16,11.85,7.6h0a1.73,1.73,0,0,0,.5-.05l.12,0a2.85,2.85,0,0,0,.41-.18l.08-.05C118.53,285.75,121.86,278.94,124.63,272.28Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.73,258.51c-5.81,2.06-9.52,7.15-13.65,19.48s-4.14,35.29-4.14,35.29,2.81,8.58,15.38,13.65,26,2.61,29.49,1.31c0,0,3-27.89,4-37.56s5.58-17.92-3.9-23.55C142.81,261.11,130.57,256.81,125.73,258.51Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.08,278c-4.14,12.33-4.14,35.29-4.14,35.29s2.81,8.58,15.38,13.65,26,2.61,29.49,1.31c0,0,3-27.89,4-37.56.25-2.34.63-4.59.94-6.75-2.18-7.23-4.61-12.76-7.23-14.7-8.4-6.24-17.9-9.86-26.88-9.8C119,261.94,115.7,267.19,112.08,278Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,291.42c1.42,17.81,3.17,25.33,5.27,29.87,1.84,3.95,16.47-10.22,16.47-10.22l-3.77-25.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,291.42c1.42,17.81,3.17,25.33,5.27,29.87,1.84,3.95,16.47-10.22,16.47-10.22l-3.77-25.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.94,267.13a20.71,20.71,0,0,0-10.37,18.16A123.19,123.19,0,0,0,143.79,303s13.46,4.28,19.77-3.81c0,0-.74-12.51-1.88-19.73C160.39,271.27,155.4,268.45,152.94,267.13Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.94,267.13a20.71,20.71,0,0,0-10.37,18.16A123.19,123.19,0,0,0,143.79,303s13.46,4.28,19.77-3.81c0,0-.74-12.51-1.88-19.73C160.39,271.27,155.4,268.45,152.94,267.13Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.63,287.34c-.58-8.58-5.26-14.15-10.36-18.32h0a20.49,20.49,0,0,0-7.69,16.27A123.19,123.19,0,0,0,143.79,303s11.33,3.59,18.06-2.06C161.45,296.12,160.81,290.15,160.63,287.34Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,259.94l-1.22,4.44c-6.76,2.05-14.33-1.28-15.08-4.27l2.16-9.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.45,241.79s3,6.23,2.54,6.74-3.36.65-3.36.65Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.23,240.15a4.54,4.54,0,1,1,3.92,5.09A4.55,4.55,0,0,1,155.23,240.15Zm1,.13a3.53,3.53,0,1,0,4-3.05A3.54,3.54,0,0,0,156.23,240.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35,224.45c7.44,2.6,10,6.53,9.17,18.78-.89,12.79-3.51,16.34-5.4,17.84-1.28,1-7.56.41-10.61-.87-3.81-1.6-12.33-5.93-15.69-12.86-3.95-8.15-3.92-18.5,1.89-22C139.88,220.42,149.32,223.39,152.35,224.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44,248.48a19.59,19.59,0,0,0,1.84,2.59l-2,9c.68,2.73,7,5.72,13.28,4.68l2.77-11Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,260.88l.66-2.23a23.09,23.09,0,0,0,8.61,2.65C154.09,261.83,149.5,261.81,146.37,260.88Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.78 241.94 150.01 240.64 150.34 241.7 163.56 242.94 163.78 241.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.75,230.24a2.61,2.61,0,0,1-.06.27,3.93,3.93,0,0,1-4,2.88,4.8,4.8,0,0,1-2.67,3.79,4.73,4.73,0,0,1-3.58.2c-.13.49-.12,1.08-1.53,1.75a1.28,1.28,0,0,1-.55.1,2.71,2.71,0,0,1-1.55-.46,5.15,5.15,0,0,1,.5,3c-.63,2.24-2.1,1.46-2.13.68,0,0-.56-4.29-4.4-3.68-3.4.53-4.34,4.38-2.56,8.12,1.55,3.27,4.66,2.64,5.08,1.84.08,1.43-.47,6.76-5,7.72-2.68.56-8.58.23-11.86-1.63-.08-1.11-3.38-7.37-4.89-13.51-1.24-5-1.13-8.81-.44-10.78,1.14-3.26,3.37-5.4,5.18-5.91,1.41-3.38,2.74-4.32,6.26-6.18,4.33-2.28,9.79-1.88,14.3-.29,2.18.77,4.06,2.07,6.37,2.63A18.42,18.42,0,0,0,166,221a6.89,6.89,0,0,1-2.45,5.08A4,4,0,0,1,165.75,230.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.72,326.43c3.45-.61,8.43-2,12.7-.24,2.43,1,6.7,2,8.37-1.57s1-5.62,3.45-9.31c2.64-4,5.25-6.09,5.15-10.28s-4.5-11.77-6.94-8.44c-2.64,3.61-3.32,6.31-8.46,11.92-3.16,3.46-3.88,5.74-8.52,5.95a50.67,50.67,0,0,1-6-.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.72,326.43c3.45-.61,8.43-2,12.7-.24,2.43,1,6.7,2,8.37-1.57s1-5.62,3.45-9.31c2.64-4,5.25-6.09,5.15-10.28s-4.5-11.77-6.94-8.44c-2.64,3.61-3.32,6.31-8.46,11.92-3.16,3.46-3.88,5.74-8.52,5.95a50.67,50.67,0,0,1-6-.46Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24,315.31c2.64-4,5.25-6.09,5.15-10.28s-4.5-11.77-6.94-8.44c-2.64,3.61-3.32,6.31-8.46,11.92-1.9,2.08-2.92,3.73-4.45,4.77h0c2.64,1.68,1.79,10.08-1.34,12h0a11.7,11.7,0,0,1,4.23.86c2.43,1,6.7,2,8.37-1.57S303.82,319,306.24,315.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24,315.31c2.64-4,5.25-6.09,5.15-10.28s-4.5-11.77-6.94-8.44c-2.64,3.61-3.32,6.31-8.46,11.92-1.9,2.08-2.92,3.73-4.45,4.77h0c2.64,1.68,1.79,10.08-1.34,12h0a11.7,11.7,0,0,1,4.23.86c2.43,1,6.7,2,8.37-1.57S303.82,319,306.24,315.31Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.26,306c-1.15,3.53-7.54,8.46-7.23,13s-.11,8-3.77,8.2a4.37,4.37,0,0,0,4.53-2.52c1.67-3.6,1-5.62,3.45-9.31,2.64-4,5.25-6.09,5.15-10.28s-4.5-11.77-6.94-8.44C306.55,295.91,310.41,302.44,309.26,306Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,322.38c3.5-.19,8.61-1,12.64,1.29,2.28,1.3,6.4,2.81,8.49-.56s1.7-5.45,4.54-8.83c3.11-3.69,5.95-5.42,6.34-9.6s-3.06-12.22-5.87-9.2c-3.06,3.27-4.06,5.87-9.83,10.82-3.55,3.05-4.54,5.23-9.17,4.89-1.46-.11-6-.6-6-.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,322.38c3.5-.19,8.61-1,12.64,1.29,2.28,1.3,6.4,2.81,8.49-.56s1.7-5.45,4.54-8.83c3.11-3.69,5.95-5.42,6.34-9.6s-3.06-12.22-5.87-9.2c-3.06,3.27-4.06,5.87-9.83,10.82-3.55,3.05-4.54,5.23-9.17,4.89-1.46-.11-6-.6-6-.6Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,314.28c3.11-3.69,5.95-5.42,6.34-9.6s-3.06-12.22-5.87-9.2c-3.06,3.27-4.06,5.87-9.83,10.82-2.14,1.84-3.35,3.36-5,4.2h0c2.42,2,.58,10.23-2.78,11.8h0a11.76,11.76,0,0,1,4.1,1.37c2.28,1.3,6.4,2.81,8.49-.56S280.76,317.66,283.6,314.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,314.28c3.11-3.69,5.95-5.42,6.34-9.6s-3.06-12.22-5.87-9.2c-3.06,3.27-4.06,5.87-9.83,10.82-2.14,1.84-3.35,3.36-5,4.2h0c2.42,2,.58,10.23-2.78,11.8h0a11.76,11.76,0,0,1,4.1,1.37c2.28,1.3,6.4,2.81,8.49-.56S280.76,317.66,283.6,314.28Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.72,305.37c-1.57,3.38-8.5,7.5-8.73,12s-1.07,7.94-4.73,7.68a4.35,4.35,0,0,0,4.8-1.95c2.09-3.38,1.7-5.45,4.54-8.83,3.11-3.69,5.95-5.42,6.34-9.6s-3.06-12.22-5.87-9.2C286.23,295.06,289.28,302,287.72,305.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,310.26s-21.79-4.19-26.27-5a19.31,19.31,0,0,0-11.76,1,77.89,77.89,0,0,0-17.12,9.27c-5.34,4-35.7,27.74-35.7,27.74s24.06-2.92,37.68-8.23c6.64-2.59,15.75-8.55,23.35-14a15.94,15.94,0,0,0,4.25,3.52c3.45,1.3,11.09.25,15.2-.31s9.72-1.64,9.72-1.64S263.24,314.5,261,310.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,310.26c-4.8-.75-9.58-1.58-14.36-2.42-2.39-.41-4.77-.87-7.16-1.3s-4.78-1-7.15-1.22a16.71,16.71,0,0,0-7.06.6,47.09,47.09,0,0,0-6.75,2.57q-3.3,1.5-6.47,3.29a71.31,71.31,0,0,0-6.2,3.79,72,72,0,0,1,12.42-7.6,42.19,42.19,0,0,1,6.81-2.71,17.64,17.64,0,0,1,7.33-.69c2.45.3,4.8.86,7.19,1.29s4.77.92,7.14,1.41C251.51,308.23,256.27,309.21,261,310.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,314.27c-11.59-.74-18.74-1.09-28.07-1.61-8.46-.49-17-2.18-22.68.78-10.31,5.38-33.16,19-33.16,19l-38,1.57c1.23,8,4.36,17.58,11.22,21.59,5,2.92,25,12.69,37.92,4.45,11-7,25.06-19.07,31.16-24.42h0l1.1-1c2.45-2.1,4.56-3.3,11-2.76,8.58.72,17.84-2.56,29.65-6C286.18,325.89,290.72,318.54,286,314.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,355.56h0c5,2.92,25,12.69,37.92,4.45,11-7,25.06-19.07,31.16-24.42h0l1.1-1c2.45-2.1,4.56-3.3,11-2.76,8.58.72,17.84-2.56,29.65-6,0,0,3.58-5.83,1.05-10.12.42,3.11-2.84,4.41-12.57,5.75s-16.23-2.26-26,.84S227,342.3,220.11,345.67s-13.29,1.37-15.76-5.79L173,333.6l-9,.37a47.24,47.24,0,0,0,3.5,12.31C169.37,350.17,171.87,353.56,175.3,355.56Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "186.09 271.77 184.48 289.15 171.1 288.82 172.27 269.7 186.09 271.77",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.66,288.72c.52-5.62,2.39-11.24,8.72-11.36,1.2,0,2.29.07,3.41.13-.1,2.35,9.28,6,13.51,2.79,2,.32,9.09,2.59,9.09,2.59,2.65.77,13.38,8.36,15.57,16.73,2.26,8.65-3.12,13.68-3.12,13.68,1.59,6.2,4.82,16.46,7.46,28.48,0,0-4.05,7.1-25.44,6.34-19-.68-24.58-12.73-24.58-12.73S158.86,297.32,159.66,288.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3,341.76c-2.64-12-5.87-22.28-7.46-28.48a12.25,12.25,0,0,0,2.37-3.51c-2.2-7.67-4.16-14.24-4.66-15.06-.88-1.44-4.32-7.28-10.76-9.78-2.51-1-6.71-1.7-9.64-2.59l-1.53-1c-4.6.84-10.91-2-10.83-3.89-1.12-.06-2.21-.16-3.41-.13-6.33.12-8.2,5.74-8.72,11.36-.8,8.6,4.62,46.65,4.62,46.65s5.55,12.05,24.58,12.73C210.25,348.86,214.3,341.76,214.3,341.76Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.82,235.49c4.43-2.35,13.23-1.23,16.73,5.27s-.81,13.27-2.06,13.54S179.82,235.49,179.82,235.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,254.46s3.82,5,3.43,5.54-2.87,1.12-2.87,1.12Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,239.78c3.08,1.48,8.42,4.23,10.09,15.37,1.73,11.44.36,15.5-1.16,17.06-1,1-8.56,1.89-10.71,1.38-3.63-.85-11.11-5.19-14.9-11-4.46-6.84-5.61-16.11-.81-19.9C175.56,237.35,183.68,238.53,186.29,239.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.94,271l.11,1.26a17.15,17.15,0,0,0,3.46,1.33c2.15.51,8.2.38,10.71-1.38C193.37,272.94,180.94,271,180.94,271Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.32,272.94c.6-2.07,1.88-3.39,2.43-5.14s0-4-.39-5.8c-1.12-5.21-2.81-13.62,3.48-16.38a10.43,10.43,0,0,1,1.4-5,16.71,16.71,0,0,1,11.56-6.48,36.35,36.35,0,0,1,11,0,15.71,15.71,0,0,1,8.77,4.47,8.41,8.41,0,0,1,2.36,6c0,2.05-1.11,3.65-2.19,5.28a10.16,10.16,0,0,0-1.44,3.05,5.48,5.48,0,0,0,.34,3.74,3.82,3.82,0,0,1-.21,3.57,3.18,3.18,0,0,1-3.18,1.51,1.79,1.79,0,0,0,.55-2.42,4.51,4.51,0,0,0-1.77-1.33c-.76-.46-1-1.14-1.56-1.81-1.2-1.44-2.9-2.36-4.77-1.67-3.5,1.28-3,6-.18,8.32s4.68.72,4.73.7a7.05,7.05,0,0,1,3.55,2.44c1,1.44.64,3.71-.24,5.11-.67,1.07-2,3.81.24,4.33,1.07.25,1.9-.31,1.9-1.3a4.08,4.08,0,0,1,1.14,1.48,4.83,4.83,0,0,1,.17,2.84c-.7,2.45-3.38,3.77-6.56,4a27.27,27.27,0,0,1-4.67-.53,19.85,19.85,0,0,0-2.78-.05,16.52,16.52,0,0,0-5,1.38,16,16,0,0,1-4,1,9.39,9.39,0,0,1-7-1.89,7.5,7.5,0,0,1-2.54-5.74,4.48,4.48,0,0,0-.85,2.16,4.05,4.05,0,0,0,.71,2.91,5.49,5.49,0,0,1-2.72-.83,5.21,5.21,0,0,1-2.28-2.68A7.92,7.92,0,0,1,155.32,272.94Z",
    style: {
      fill: "#263238"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.94,268.72c1.06-1.83.28-5.34-.81-7.14,1.37.95,3.63,4.8,2.35,7.65s-3,4.61-3,7.41a4.48,4.48,0,0,0-.85,2.16,4.05,4.05,0,0,0,.71,2.91C155.86,277,160.89,270.56,161.94,268.72Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-40",
    d: "M200.47,332c1.21,1.09,6.34,1,9.1.83a2.55,2.55,0,0,0,2.18-1.69h0s1,.56,1.21.73a1.63,1.63,0,0,1,.62,1.84,5.15,5.15,0,0,1-1.06,1.35,3.24,3.24,0,0,0-.86,1.72,3.1,3.1,0,0,1-1.08,2,8.12,8.12,0,0,0-.75.56,2.78,2.78,0,0,0-.5.82,5.79,5.79,0,0,1-.85,1.79,3.23,3.23,0,0,1-1.17.87,34.51,34.51,0,0,1-5.1,1.16c-1.47.32-4.49-.67-6.2-1.38-5.07-2.1-8.94-3.66-11.95-4.63s-23.42-7.15-29.16-10-11.46-11.26-3.66-14.76,10.77-.75,14.56,1.09,17.55,10.64,21.48,11.83,6.65-1.1,9-1,5.85,1.37,8.39,1.37,4.16-.15,3.77,1.37-1.87,3.06-4.67,3.09S199.78,331.42,200.47,332Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,341.4c.24-.53.1-1.19.31-1.66s.82-.78,1.17-1.25a30.39,30.39,0,0,0,2.46-3.86,5.69,5.69,0,0,0,.16-3.54h0a2.55,2.55,0,0,1-2.18,1.69c-2.76.21-7.89.26-9.1-.83-.69-.53.52-1,3.33-1.07s4.28-1.58,4.67-3.09-1.22-1.37-3.77-1.37-6-1.28-8.39-1.37-5.1,2.21-9,1-17.69-10-21.48-11.83-6.77-4.59-14.56-1.09-2.08,11.91,3.66,14.76,26.16,9,29.16,10,6.88,2.53,11.95,4.63c1.71.71,4.73,1.7,6.2,1.38s2.94-.5,4.34-.92A5.12,5.12,0,0,0,207.65,341.4Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,312c-1-.07-2.33-.16-3.85-.24l-.07-1.69a4,4,0,0,1,2.62.29A2.51,2.51,0,0,1,250,312Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.68,283c9.85,2.73,12,2.82,20.32,20.93,2.5,5.44,6.24,14.09,6.24,14.09,3.48-2.26,5.7-3.44,7.85-5.31,2.94-2.54,4.51-6.21,7-9.15.27-.31.54-.62.83-.91a2.64,2.64,0,0,1,2.21-1.06c.53.1,1,.5,1.5.58s1.13-.2,1.69-.12a8.83,8.83,0,0,0,1.31.37c.46,0,.9-.34,1.35-.23a2,2,0,0,1,.71.47,2.61,2.61,0,0,0,1.75.61,2.6,2.6,0,0,1,1.62.32c1.22,1,4.24,7.6,3.86,8.71L250,312a11.3,11.3,0,0,0-1.36-1.11,2.12,2.12,0,0,0-1.23-.38,1.08,1.08,0,0,0-.82.51,2.85,2.85,0,0,0-.37.6,9.24,9.24,0,0,1-4.77,4.49,20.41,20.41,0,0,0-2.31.82,12.67,12.67,0,0,0-3.28,2.79c-1,1.12-6.86,8.79-11.64,13-3.83,3.41-8.37,4.7-13.5-1.77s-11-18.29-14.42-25.21C191.4,295.75,192,287.81,194.68,283Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.13,311.26c-1-1.64-3.23-1.78-4.86.4-1,1.37-2.38,2.1-5.09,2.25s-4.56,3.43-10.18,9-6.06,5.49-8.6,4.14-5-7.55-7.45-14.17-8.31-21.1-10.94-23.41a16.28,16.28,0,0,0-8.15-4.56l-.07,0c-1.85,4.89-1.79,12.05,2.51,20.86,3.38,6.92,9.36,18.82,14.42,25.21s9.67,5.18,13.5,1.77c4.78-4.24,10.67-11.91,11.64-13a12.67,12.67,0,0,1,3.28-2.79,20.41,20.41,0,0,1,2.31-.82,9.24,9.24,0,0,0,4.77-4.49,2.85,2.85,0,0,1,.37-.6,1.14,1.14,0,0,1,1-.52A4.29,4.29,0,0,1,249.13,311.26Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,318l.94-.62a12,12,0,0,1,1,8.31A19.47,19.47,0,0,0,221.24,318Z",
    style: {
      fill: "#f28f8f"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M126,291.31,74.2,261.41a8.79,8.79,0,0,0-8,0l-7,4A7.21,7.21,0,0,0,56,272.28L70.57,364a10.89,10.89,0,0,0,4.7,6.83l51.79,29.91a8.84,8.84,0,0,0,8,0l7-4a7.13,7.13,0,0,0,3.27-6.82l-14.65-91.8A10.91,10.91,0,0,0,126,291.31Z",
    style: {
      fill: "#37474f"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.07,396.77l-7,4c-2.2,1.26-4.31.24-4.7-2.27l-14.58-91.74a7.2,7.2,0,0,1,3.26-6.84l7-4c2.2-1.27,4.3-.27,4.7,2.24L145.34,390A7.13,7.13,0,0,1,142.07,396.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126,291.31,74.2,261.41a8.79,8.79,0,0,0-8,0l-7,4c-2.2,1.27-2.2,3.33,0,4.6l51.79,29.9a8.79,8.79,0,0,0,8,0l7-4C128.19,294.64,128.19,292.58,126,291.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.26,270l51.79,29.9a10.91,10.91,0,0,1,4.7,6.84l14.58,91.74c.39,2.51-1.07,3.52-3.27,2.25L75.27,370.86a10.89,10.89,0,0,1-4.7-6.83L56,272.28C55.6,269.77,57.06,268.77,59.26,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.26,270l51.79,29.9a10.91,10.91,0,0,1,4.7,6.84l14.58,91.74c.39,2.51-1.07,3.52-3.27,2.25L75.27,370.86a10.89,10.89,0,0,1-4.7-6.83L56,272.28C55.6,269.77,57.06,268.77,59.26,270Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,327.81,137.44,297.9a8.79,8.79,0,0,0-8,0l-7,4a7.21,7.21,0,0,0-3.27,6.84l14.58,91.75a10.91,10.91,0,0,0,4.7,6.84l51.79,29.9a8.84,8.84,0,0,0,8,0l7-4a7.13,7.13,0,0,0,3.27-6.82l-14.65-91.8A10.89,10.89,0,0,0,189.23,327.81Z",
    style: {
      fill: "#37474f"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M205.31,433.26l-7,4a3,3,0,0,1-4.7-2.26L179,343.27a7.18,7.18,0,0,1,3.26-6.84l7-4c2.2-1.27,4.3-.26,4.7,2.24l14.65,91.8A7.13,7.13,0,0,1,205.31,433.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,327.81,137.44,297.9a8.79,8.79,0,0,0-8,0l-7,4c-2.2,1.27-2.2,3.33,0,4.6l51.79,29.9a8.79,8.79,0,0,0,8,0l7-4C191.43,331.13,191.43,329.07,189.23,327.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,306.53l51.79,29.9a10.91,10.91,0,0,1,4.7,6.84L193.57,435c.39,2.5-1.07,3.51-3.27,2.24l-51.79-29.9a10.91,10.91,0,0,1-4.7-6.84l-14.58-91.75C118.84,306.26,120.3,305.26,122.5,306.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,306.53l51.79,29.9a10.91,10.91,0,0,1,4.7,6.84L193.57,435c.39,2.5-1.07,3.51-3.27,2.24l-51.79-29.9a10.91,10.91,0,0,1-4.7-6.84l-14.58-91.75C118.84,306.26,120.3,305.26,122.5,306.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.48 438.37 214.74 456.96 211.09 459.06 207.48 456.98 203.7 438.37 211.09 434.1 218.48 438.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.09 459.06 211.09 442.63 218.48 438.37 214.74 456.96 211.09 459.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.48 438.37 216.06 450.37 211.09 453.24 206.14 450.38 203.7 438.37 211.09 434.1 218.48 438.37",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.07 410.31 263.32 428.9 259.68 431.01 256.07 428.92 252.29 410.31 259.68 406.05 267.07 410.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.68 431.01 259.68 414.58 267.07 410.31 263.32 428.9 259.68 431.01",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.07 410.31 264.65 422.32 259.68 425.19 254.73 422.33 252.29 410.31 259.68 406.05 267.07 410.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.84,339.63c-2.8-1.61-6.73-1.32-11.17,1.24l-55.08,31.8a7.83,7.83,0,0,0-3.54,7.44L196.4,439a3.56,3.56,0,0,0,1.61,2.64c1,.57,11.38,6.57,12.21,7.05a3.41,3.41,0,0,0,3.48-.21L266,418.27a10.29,10.29,0,0,0,4.59-7.49l2.8-53.37c.28-5.31-1.38-9-4.27-10.71C267,345.46,259,340.85,256.84,339.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.1,448.59c-1.39-.79-11.16-6.43-12.09-7A3.58,3.58,0,0,1,196.4,439L187,380.11a7.3,7.3,0,0,1,.61-3.94l12.17,7a7.35,7.35,0,0,0-.59,4L208.59,446A3.61,3.61,0,0,0,210.1,448.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.1,448.59c-1.39-.79-11.16-6.43-12.09-7A3.58,3.58,0,0,1,196.4,439L187,380.11a7.3,7.3,0,0,1,.61-3.94l12.17,7a7.35,7.35,0,0,0-.59,4L208.59,446A3.61,3.61,0,0,0,210.1,448.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.59,446l-9.36-58.86a7.85,7.85,0,0,1,3.55-7.44l55.08-31.8c9.08-5.24,16.05-1,15.5,9.5l-2.8,53.37a10.29,10.29,0,0,1-4.59,7.49L213.7,448.45C211.32,449.82,209,448.73,208.59,446Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Popcorns--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Popcorn--inject-40"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-40",
    d: "M320.55,418.65,296.39,404.7c-.42-.24-.42-.63,0-.88l24.07-14a1.66,1.66,0,0,1,1.52,0l24.25,14a.46.46,0,0,1,0,.87l-24.16,13.95A1.69,1.69,0,0,1,320.55,418.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--popcorn--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.48,360.72a1.44,1.44,0,0,0-1.12-2.36,1.47,1.47,0,0,0-1.05.45,3.31,3.31,0,0,0,0-.45,4.4,4.4,0,0,0-4.4-4.4,4.31,4.31,0,0,0-2.16.58,2,2,0,0,0,.15-.77,1.92,1.92,0,0,0-2.9-1.65,5,5,0,0,0-9.36-3,1.74,1.74,0,0,0-3.19,0,3.9,3.9,0,0,0-7.22,2.06,3.68,3.68,0,0,0,.05.58,1.47,1.47,0,0,0-.91-.33,1.45,1.45,0,0,0-1.45,1.46h0a3.51,3.51,0,0,0-1.74-.47,3.47,3.47,0,0,0-3.43,3,2.19,2.19,0,0,0-.77-.14,2.16,2.16,0,0,0-2,2.93,5.06,5.06,0,0,0,1.87,9.77L323,380.25l19.45-12.52a3.79,3.79,0,0,0,2-7Zm-2.54-.54v0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.48,360.72a1.44,1.44,0,0,0-1.12-2.36,1.47,1.47,0,0,0-1.05.45,3.31,3.31,0,0,0,0-.45,4.4,4.4,0,0,0-4.4-4.4,4.31,4.31,0,0,0-2.16.58,2,2,0,0,0,.15-.77,1.92,1.92,0,0,0-2.9-1.65,5,5,0,0,0-9.36-3,1.74,1.74,0,0,0-3.19,0,3.9,3.9,0,0,0-7.22,2.06,3.68,3.68,0,0,0,.05.58,1.47,1.47,0,0,0-.91-.33,1.45,1.45,0,0,0-1.45,1.46h0a3.51,3.51,0,0,0-1.74-.47,3.47,3.47,0,0,0-3.43,3,2.19,2.19,0,0,0-.77-.14,2.16,2.16,0,0,0-2,2.93,5.06,5.06,0,0,0,1.87,9.77L323,380.25l19.45-12.52a3.79,3.79,0,0,0,2-7Zm-2.54-.54v0Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.2,352.44a3.47,3.47,0,0,0-3.43,3,2.19,2.19,0,0,0-.77-.14,2.16,2.16,0,0,0-2,2.93,5.06,5.06,0,0,0,1.87,9.77L323,380.25l18.12-11.66.47-1.74c-2.47,3.2-5.77.65-5.77.65s-.25,1.63-1.63,1.73a1.9,1.9,0,0,1-1.88-1,3.79,3.79,0,0,1-3.13,2.84c-2.69.5-4.26-2.46-4.26-2.46a1.61,1.61,0,0,1-1.92,1c-1.41-.36-.91-1.13-.91-1.13a1.91,1.91,0,0,1-2.17,0c-1.38-.74-1.48-2.9-1.48-2.9a4.07,4.07,0,0,1-4.33-.85c-2-1.89-.3-4.5-.3-4.5-3,.59-2.89-1.87-2.89-1.87C306.76,357.68,307.06,353.57,309.2,352.44Z",
    style: {
      fill: "#FB923C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.71 374.87 327.08 412.7 331.04 410.41 332.33 372.2 327.71 374.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.33 372.2 331.04 410.41 334.98 408.14 336.97 369.53 332.33 372.2",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.34,376.82a2.48,2.48,0,0,1-1.23.29v37.46a2.6,2.6,0,0,0,1.23-.29l2.74-1.58.63-37.83Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,405.87l2.67-1.54a3.08,3.08,0,0,0,1.36-2.13l3.35-38.05-4.66,2.7Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.97 369.53 334.98 408.14 338.9 405.87 341.62 366.85 336.97 369.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.25,369.53l2,38.61,3.94,2.27-1.3-38.21Zm12.62,7.29-3.37-1.95.64,37.83,2.73,1.58a2.61,2.61,0,0,0,1.24.29V377.11A2.5,2.5,0,0,1,321.87,376.82Zm-21.93-12.67,3.35,38.05a3,3,0,0,0,1.36,2.13l2.67,1.54-2.72-39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.25,369.53l2,38.61,3.94,2.27-1.3-38.21Zm12.62,7.29-3.37-1.95.64,37.83,2.73,1.58a2.61,2.61,0,0,0,1.24.29V377.11A2.5,2.5,0,0,1,321.87,376.82Zm-21.93-12.67,3.35,38.05a3,3,0,0,0,1.36,2.13l2.67,1.54-2.72-39Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,374.87l-4.62-2.67,1.3,38.21,4,2.29Zm-13.9-8,2.72,39,3.92,2.27-2-38.61Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,374.87l-4.62-2.67,1.3,38.21,4,2.29Zm-13.9-8,2.72,39,3.92,2.27-2-38.61Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.47,368.78a1.58,1.58,0,0,1-.4-.88,1.61,1.61,0,0,0-.21.55,2.2,2.2,0,0,1-.37.05,2.41,2.41,0,0,1-1.95-3.81,2.4,2.4,0,0,0,.63,4.72,2.33,2.33,0,0,0,1.67-.69,1.56,1.56,0,1,0,3.11-.15,1.35,1.35,0,0,1-.27.32A1.57,1.57,0,0,1,322.47,368.78Zm-7.26-11a2.4,2.4,0,0,1-4.26.47,2.38,2.38,0,0,0,.48,1.68,1.56,1.56,0,0,1-2,.61,1.6,1.6,0,0,1-.69-.67,1.58,1.58,0,0,0,.85,1.71,1.55,1.55,0,0,0,2.24-1.26,2.43,2.43,0,0,0,.7.41,2.4,2.4,0,0,0,2.86-3.57A2.23,2.23,0,0,1,315.21,357.8Zm23.66,4.35a1.55,1.55,0,0,1-2.6-1,1.55,1.55,0,0,0,.15,1.89l0,0a2.85,2.85,0,0,1-.34.36,2.41,2.41,0,0,1-3.38-.33,2.37,2.37,0,0,1-.5-1.05,1.57,1.57,0,0,0,.13-2.87,1.87,1.87,0,0,1,.13.4,1.57,1.57,0,0,1-2.25,1.66,1.57,1.57,0,0,0,1.69.89h0a2.4,2.4,0,1,0,4.58,1,1.56,1.56,0,0,0,2.11,0,1.59,1.59,0,0,0,.5-1.33A1.31,1.31,0,0,1,338.87,362.15Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.47,368.78a1.58,1.58,0,0,1-.4-.88,1.61,1.61,0,0,0-.21.55,2.2,2.2,0,0,1-.37.05,2.41,2.41,0,0,1-1.95-3.81,2.4,2.4,0,0,0,.63,4.72,2.33,2.33,0,0,0,1.67-.69,1.56,1.56,0,1,0,3.11-.15,1.35,1.35,0,0,1-.27.32A1.57,1.57,0,0,1,322.47,368.78Zm-7.26-11a2.4,2.4,0,0,1-4.26.47,2.38,2.38,0,0,0,.48,1.68,1.56,1.56,0,0,1-2,.61,1.6,1.6,0,0,1-.69-.67,1.58,1.58,0,0,0,.85,1.71,1.55,1.55,0,0,0,2.24-1.26,2.43,2.43,0,0,0,.7.41,2.4,2.4,0,0,0,2.86-3.57A2.23,2.23,0,0,1,315.21,357.8Zm23.66,4.35a1.55,1.55,0,0,1-2.6-1,1.55,1.55,0,0,0,.15,1.89l0,0a2.85,2.85,0,0,1-.34.36,2.41,2.41,0,0,1-3.38-.33,2.37,2.37,0,0,1-.5-1.05,1.57,1.57,0,0,0,.13-2.87,1.87,1.87,0,0,1,.13.4,1.57,1.57,0,0,1-2.25,1.66,1.57,1.57,0,0,0,1.69.89h0a2.4,2.4,0,1,0,4.58,1,1.56,1.56,0,0,0,2.11,0,1.59,1.59,0,0,0,.5-1.33A1.31,1.31,0,0,1,338.87,362.15Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drink--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Soda--inject-40"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.54,423.23c-5.34,3.08-14,3.08-19.33,0s-5.34-8.08,0-11.17,14-3.08,19.33,0S366.87,420.14,361.54,423.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.69,416.2h0V383.93H342V416.2h0c-.09,1.67.95,3.35,3.16,4.62a16.91,16.91,0,0,0,15.33,0C362.74,419.55,363.79,417.87,363.69,416.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.31,422.1c-4,1-8.83.62-12.1-1.28-2.2-1.27-3.25-2.95-3.16-4.62h0V383.93c0,1.6,1.06,3.21,3.18,4.43a9.32,9.32,0,0,0,1.05.52v30C346.26,420.64,352.3,422.8,357.31,422.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.87,
    cy: 383.93,
    rx: 10.84,
    ry: 6.26,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.87,
    cy: 383.93,
    rx: 10.18,
    ry: 5.75,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.07,380.92a16.18,16.18,0,0,0-14.39,0,3.6,3.6,0,0,0,0,7.07,16.18,16.18,0,0,0,14.39,0,3.6,3.6,0,0,0,0-7.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,412.54c0,1.61,1.05,3.23,3.18,4.46a17,17,0,0,0,15.33,0c2.11-1.22,3.17-2.82,3.17-4.43V387.46c0,1.6-1.06,3.2-3.17,4.42a16.91,16.91,0,0,1-15.33,0c-2.13-1.23-3.19-2.84-3.18-4.46Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,412.54c0,1.61,1.05,3.23,3.18,4.46a17,17,0,0,0,15.33,0c2.11-1.22,3.17-2.82,3.17-4.43V387.46c0,1.6-1.06,3.2-3.17,4.42a16.91,16.91,0,0,1-15.33,0c-2.13-1.23-3.19-2.84-3.18-4.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,417a10.26,10.26,0,0,0,1.05.52V392.41a10.3,10.3,0,0,1-1.05-.53c-2.13-1.23-3.19-2.84-3.18-4.46v25.12C342,414.15,343.08,415.77,345.21,417Z",
    style: {
      fill: "#FB923C",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.29,384.88h0c-1.52-.88-3.58-1.12-4.6-.53s-.62,1.78.91,2.66h0c1.52.88,3.58,1.12,4.6.53S359.81,385.76,358.29,384.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.23,383l-1.88-1.08c-1.52-.88-3.58-1.12-4.6-.53s-.62,1.78.91,2.66l1.87,1.08c1.53.88,3.59,1.12,4.61.53S355.75,383.84,354.23,383Zm-3.65,0a2.22,2.22,0,0,1-2,0,.61.61,0,0,1,0-1.16,2.22,2.22,0,0,1,2,0A.61.61,0,0,1,350.58,383Zm3.72,1.93a2.22,2.22,0,0,1-2,0,.61.61,0,0,1,0-1.16,2.22,2.22,0,0,1,2,0A.61.61,0,0,1,354.3,384.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.35 412.98 358.17 410.83 355.44 412.37 351.16 409.47 352.97 406.17 356.43 409.79 358.29 408.46 362.35 412.98",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.17 398.6 354.73 404.58 356.9 403.54 358 407.64 359.81 406.5 362.05 411.08 361.21 402.95 359.25 404.27 358.64 398.85 355.68 400.42 354.85 395.5 350.17 398.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.59,403.44a.11.11,0,0,1-.15,0l-.09-.06a.54.54,0,0,0-.73,0l-.08.07a.11.11,0,0,1-.15,0,.1.1,0,0,1,0-.15l.06-.09h0a.55.55,0,0,0,0-.73l-.07-.08a.11.11,0,0,1,.15-.16l.08.06a.55.55,0,0,0,.74,0l.08-.07a.11.11,0,0,1,.16.15l-.07.09a.56.56,0,0,0,0,.73l.08.08A.11.11,0,0,1,350.59,403.44Zm-.82-.36a.78.78,0,0,1,.4,0,.29.29,0,1,0-.42-.39A.81.81,0,0,1,349.77,403.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,406.12a.71.71,0,1,1,0-1A.7.7,0,0,1,351.52,406.12Zm-.88-.81a.49.49,0,1,0,.69,0A.49.49,0,0,0,350.64,405.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,405.67a.1.1,0,0,1-.15,0l-.27-.25a.11.11,0,1,1,.15-.17l.27.25A.11.11,0,0,1,347.76,405.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.78,406l-.25.28a.12.12,0,0,1-.16,0,.1.1,0,0,1,0-.15l.25-.28a.11.11,0,0,1,.16,0A.1.1,0,0,1,347.78,406Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.38,406.24a.12.12,0,0,1-.16,0L348,406a.1.1,0,0,1,0-.15.11.11,0,0,1,.16,0l.27.25A.11.11,0,0,1,348.38,406.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.34,405.37l-.25.27a.1.1,0,0,1-.15,0,.11.11,0,0,1,0-.16l.25-.27a.11.11,0,1,1,.16.15Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.54,399.59a.71.71,0,0,1,.57-1.31.71.71,0,1,1-.57,1.31Zm.48-1.11a.49.49,0,1,0-.39.9.48.48,0,0,0,.64-.25A.49.49,0,0,0,361,398.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74,395.89a.12.12,0,0,1-.06-.15l.15-.34a.11.11,0,1,1,.2.09l-.14.34A.13.13,0,0,1,359.74,395.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.45,396l-.34-.15a.11.11,0,1,1,.09-.2l.34.15a.1.1,0,0,1,0,.14A.11.11,0,0,1,359.45,396Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.41,396.65a.11.11,0,0,1-.06-.15l.15-.34a.1.1,0,0,1,.14-.05.11.11,0,0,1,.06.14l-.15.34A.1.1,0,0,1,359.41,396.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.21,396.33l-.34-.14a.11.11,0,0,1-.05-.15A.11.11,0,0,1,360,396l.34.15a.11.11,0,1,1-.09.2Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shine--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.74,413.13a.1.1,0,0,1-.05.14l-.09.05a.56.56,0,0,0-.28.68l0,.1a.11.11,0,0,1-.06.14.11.11,0,0,1-.14-.05l0-.1h0a.57.57,0,0,0-.68-.28l-.11,0a.1.1,0,0,1-.13-.06.11.11,0,0,1,.05-.15l.1-.05a.57.57,0,0,0,.28-.68l0-.1a.12.12,0,0,1,.06-.14.12.12,0,0,1,.15.06l0,.09a.57.57,0,0,0,.69.28l.1,0A.1.1,0,0,1,353.74,413.13Zm-.67.59a.29.29,0,1,0-.22-.53.84.84,0,0,1-.15.38A.85.85,0,0,1,353.07,413.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.44,413.18a.72.72,0,1,1-1.32.55.72.72,0,0,1,1.32-.55Zm-1.11.47a.49.49,0,0,0,.64.26.49.49,0,1,0-.64-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,415.7a.11.11,0,0,1-.06.14l-.34.14a.11.11,0,0,1-.15-.06.11.11,0,0,1,.06-.14l.34-.14A.11.11,0,0,1,355.28,415.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,415.81l.14.35a.11.11,0,0,1-.06.14.1.1,0,0,1-.14-.06l-.15-.34a.11.11,0,0,1,.21-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.05,415.37a.11.11,0,0,1-.06.15l-.34.14a.11.11,0,0,1-.15-.06.12.12,0,0,1,.06-.14l.34-.15A.12.12,0,0,1,356.05,415.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.25,415l.14.35a.11.11,0,0,1-.06.14.12.12,0,0,1-.15-.06l-.14-.34a.12.12,0,0,1,.06-.15A.13.13,0,0,1,355.25,415Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-40",
    d: "M63.73,31l-3,17.63a4.67,4.67,0,1,0,2.35,4.85l2.69-15.8,16.61-1.48h0L79.75,51.85a4.45,4.45,0,0,0-1.49-.55,4.68,4.68,0,1,0,3.84,5.4h0l4.4-26.16Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-40",
    d: "M116.37,33.56a5.65,5.65,0,0,1,2.06-1.05,11.83,11.83,0,0,1,3.08-.34,22,22,0,0,0,4.14-.23,5.16,5.16,0,0,0,3.42-2.15,5.58,5.58,0,0,1-2.4.23c-1.93-.26-3.78-1.78-5.61-2.43-2.73-1-5.06-.3-7.8,1.11.58,2.47,1.09,5,1.63,7.44.43,2,.86,3.89,1.28,5.84,0,.18.52,2.66.52,2.66a5.21,5.21,0,0,0-2.29,0,4.28,4.28,0,1,0,5.1,3.25Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-40",
    d: "M116.37,33.56a5.65,5.65,0,0,1,2.06-1.05,11.83,11.83,0,0,1,3.08-.34,22,22,0,0,0,4.14-.23,5.16,5.16,0,0,0,3.42-2.15,5.58,5.58,0,0,1-2.4.23c-1.93-.26-3.78-1.78-5.61-2.43-2.73-1-5.06-.3-7.8,1.11.58,2.47,1.09,5,1.63,7.44.43,2,.86,3.89,1.28,5.84,0,.18.52,2.66.52,2.66a5.21,5.21,0,0,0-2.29,0,4.28,4.28,0,1,0,5.1,3.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-40",
    d: "M33.8,90.38a8.89,8.89,0,0,1,2.66-2.71,19.37,19.37,0,0,1,4.63-2.17A34.83,34.83,0,0,0,47.43,83a8.5,8.5,0,0,0,4.21-5.15A9,9,0,0,1,48,79.43c-3.15.61-6.84-.78-10-.83-4.77-.06-8.06,2.2-11.59,5.83,2.2,3.55,4.31,7.17,6.46,10.76l5.07,8.44c.16.27,2.21,3.89,2.21,3.89a8.52,8.52,0,0,0-3.59,1.15,7,7,0,1,0,9.67,2.39Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-40",
    d: "M33.8,90.38a8.89,8.89,0,0,1,2.66-2.71,19.37,19.37,0,0,1,4.63-2.17A34.83,34.83,0,0,0,47.43,83a8.5,8.5,0,0,0,4.21-5.15A9,9,0,0,1,48,79.43c-3.15.61-6.84-.78-10-.83-4.77-.06-8.06,2.2-11.59,5.83,2.2,3.55,4.31,7.17,6.46,10.76l5.07,8.44c.16.27,2.21,3.89,2.21,3.89a8.52,8.52,0,0,0-3.59,1.15,7,7,0,1,0,9.67,2.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomecinemaAmico);
export default __webpack_public_path__ + "static/media/Home cinema-amico.72196403c713266ccc8e601dd591d55b.svg";
export { ForwardRef as ReactComponent };